// import React, { useEffect, useState,useContext } from 'react';
// import {
//   Box, Typography, Grid, Chip, Card, CardContent, IconButton, Paper,Container,Button
// } from '@mui/material';
// import { useLocation, useNavigate , useParams} from 'react-router-dom';
// import DescriptionIcon from '@mui/icons-material/Description';
// import axios from 'axios';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import BedIcon from '@mui/icons-material/Bed';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import BalconyIcon from '@mui/icons-material/Balcony';
// import HomeWorkIcon from '@mui/icons-material/HomeWork';
// import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
// import PowerIcon from '@mui/icons-material/Power';
// import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
// import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
// import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
// import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomBottomNav from './BottomNavbar/BottomNavbar';
// import { BASE_URL } from './../../Api/ApiUrls';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import CallIcon from '@mui/icons-material/Call';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { Tooltip , CircularProgress } from '@mui/material';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import AddPropertyCards from '../AddsProducts/RentDescriptionCard';

// const Rent_description = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { propertyId } = location.state = useParams ();
//   const [categories, setCategories] = useState([]);
//   const [property, setProperty] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(0);
//   const handleImageClick = (image) => {
//     setSelectedImage(image); // Update selected image
//   };
//     const { userId, logout } = useContext(AuthContext);
//     const [isSubscribed, setIsSubscribed] = useState(false);
//     const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//     const [featureRequested, setFeatureRequested] = useState('');
//     const [userPlan, setUserPlan] = useState(null);
// const [loadingLocation, setLoadingLocation] = useState(false);
// const [showSuccess, setShowSuccess] = useState(false);
// const [showFailure, setShowFailure] = useState(false);
// const [alertMessage, setAlertMessage] = useState("");

// const handleCopyMobile = (mobile) => {
//   if (!mobile) {
//     setAlertMessage("Mobile number not available");
//     setShowFailure(true);
//     return;
//   }

//   navigator.clipboard.writeText(mobile)
//     .then(() => {
//       setAlertMessage(`Mobile number copied: ${mobile}`);
//       setShowSuccess(true);
//     })
//     .catch(() => {
//       setAlertMessage("Failed to copy mobile number");
//       setShowFailure(true);
//     });
// };
    
// // Add these state variables at the top with your other states
// const [userActivities, setUserActivities] = useState([]);
// const [showLimitModal, setShowLimitModal] = useState(false);
//  useEffect(() => {
//      const checkSubscription = async () => {
//     try {
//       const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
//       const userSubscriptions = response.data;
//       const hasBuyerSubscription = Array.isArray(userSubscriptions) &&
//         userSubscriptions.some(sub => sub.user_type === "Tenant");
//       setIsSubscribed(hasBuyerSubscription);
//     } catch (error) {
//       console.error('Error checking subscription:', error);
//       setIsSubscribed(false);
//     }
//   };

//   if (userId) {
//     checkSubscription();
//   } else {
//     console.log('No user ID, defaulting to non-subscribed state');
//     setIsSubscribed(false);
//     setUserPlan(null);
//   }
// }, [userId]);


// // Add this useEffect to fetch user activities
// useEffect(() => {
//   const fetchUserActivities = async () => {
//     if (!userId) {
//       console.log('No userId - skipping activity fetch');
//       return;
//     }
    
//     try {
//       console.log(`Fetching activities for user ${userId}`);
//       const response = await fetch(`${BASE_URL}/activities/`);
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const allActivities = await response.json();
//       console.log('All activities from API:', allActivities);
      
//       // Filter activities for the current user
//       const filteredActivities = allActivities.filter(activity => 
//         activity && activity.user_id !== undefined && 
//         String(activity.user_id) === String(userId)
//       );
      
//       console.log('Filtered user activities:', filteredActivities);
//       setUserActivities(filteredActivities);
//     } catch (error) {
//       console.error('Error fetching activities:', error);
//       setUserActivities([]);
//     }
//   };

//   fetchUserActivities();
// }, [userId]);

// // Enhanced property limit check with dynamic limits
// const checkPropertyLimit = (currentPropertyId) => {
//   if (!isSubscribed) {
//     console.log('Non-subscriber - access denied');
//     setFeatureRequested("Property Access");
//     setShowSubscribeModal(true);
//     return false;
//   }

//   // If unlimited access is granted
//   if (userPlan?.no_of_properties_unlimited) {
//     console.log('User has unlimited property access');
//     return true;
//   }

//   const uniqueProperties = new Set(userActivities.map(a => a.property_id));
//   const isExistingProperty = uniqueProperties.has(currentPropertyId);
  
//   console.log(`User has accessed ${uniqueProperties.size} unique properties`);
//   console.log(`Is current property already accessed? ${isExistingProperty}`);

//   // Get the dynamic limit from user plan, default to 10 if not available
//   const propertyLimit = userPlan?.no_of_properties || 10;
  
//   if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
//     console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
//     setShowLimitModal(true);
//     return false;
//   }
  
//   return true;
// };

// // Updated handleLocationClick with limit check
// const handleLocationClick = () => {
//   if (!isSubscribed) {
//     setFeatureRequested("Location Access");
//     setShowSubscribeModal(true);
//     return;
//   }

//   if (!checkPropertyLimit(property.id)) {
//     return;
//   }

//   setLoadingLocation(true); // 🔥 START SPINNER

//   const logActivity = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: property.id,
//           activity_type: "Location",
//           property_by: property.owner,
//           activity_as: "Tenant"
//         })
//       });

//       if (!response.ok) throw new Error('Failed to log activity');

//       const newActivity = await response.json();
//       setUserActivities(prev => [...prev, newActivity]);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const openLocation = () => {
//     const openMaps = (url) => {
//       window.open(url, '_blank');
//       setLoadingLocation(false); // 🔥 STOP SPINNER
//     };

//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (pos) => {
//           const { latitude, longitude } = pos.coords;

//           if (property?.lat && property?.long) {
//             openMaps(
//               `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${property.lat},${property.long}`
//             );
//           } else if (property?.loc) {
//             openMaps(
//               `https://www.google.com/maps/search/?query=${encodeURIComponent(property.loc)}`
//             );
//           }
//         },
//         () => {
//           if (property?.lat && property?.long) {
//             openMaps(`https://www.google.com/maps/?q=${property.lat},${property.long}`);
//           } else if (property?.loc) {
//             openMaps(`https://www.google.com/maps/search/?query=${encodeURIComponent(property.loc)}`);
//           }
//         }
//       );
//     } else {
//       if (property?.lat && property?.long) {
//         openMaps(`https://www.google.com/maps/?q=${property.lat},${property.long}`);
//       } else if (property?.loc) {
//         openMaps(`https://www.google.com/maps/search/?query=${encodeURIComponent(property.loc)}`);
//       }
//     }
//   };

//   logActivity().then(openLocation);
// };


//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Fetch categories first
//         const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
//         setCategories(categoriesRes.data);
        
//         // Then fetch property if propertyId exists
//         if (propertyId) {
//           const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
//           setProperty(propertyRes.data);
//         }
//       } catch (err) {
//         console.error('Failed to fetch data:', err);
//       }
//     };

//     fetchData();
//   }, [propertyId]);

//   if (!property) {
//     return (
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '100vh' 
//       }}>
//         <Typography>Loading property...</Typography>
//       </Box>
//     );
//   }

//   // Find the category that matches the property's category_id
//   const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
//   const categoryName = propertyCategory ? propertyCategory.category : property.type;

//   const {
//     property_images = [],property_name, building_image,
//     type, price, location: loc,lat,long,
//     site_area, buildup_area,no_of_flores,
//     facing, roadwidth, list, length, width,
//     nearby, created_at, bedrooms_count,
//     bathrooms_count, parking, balcony, max_acres
//   } = property;

//   const images = property_images.length > 0 
//     ? property_images.map(img => `${BASE_URL}${img.image}`)
//     : [buildingImage];

//   return (
//     <Box sx={{ width: '100vw', minHeight: '100vh', backgroundColor: 'rgb(239, 231, 221)', pb: 10 }}>
//       {/* Header */}
//       <Box sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         zIndex: 10,
//         bgcolor: 'rgb(49, 48, 49)',
//         color: 'white',
//         p: 2,
//         display: 'flex',
//         alignItems: 'center',
//       }}>
//         <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1 }}>
//           <ArrowBackIosNewIcon />
//         </IconButton>
//         <Typography variant="h6" fontWeight="bold">
//         {categoryName?.replace(/"/g, '')|| 'Property Type'} 
//         </Typography>
//       </Box>

//       {/* Property Content */}
//       <Box sx={{ pt: '80px', px: 2 }}>
//  <Card
//   sx={{
//     borderRadius: '20px',
//     background: 'linear-gradient(135deg, #ffffff 0%,rgb(248, 248, 248) 100%)',
//     boxShadow: 5,
//     overflow: 'hidden',
//   }}
// >
//   {/* ================= IMAGE SECTION (FIXED) ================= */}
// <Box
//   sx={{
//     width: '100%',
//     height: '200px',
//     overflow: 'hidden',
//     borderTopLeftRadius: '20px',
//     borderTopRightRadius: '20px',
//     position: 'relative',

//     '& .carousel-root': { height: '100% !important', width: '100% !important' },
//     '& .carousel': { height: '100% !important', width: '100% !important' },
//     '& .carousel-slider': { height: '100% !important', width: '100% !important' },
//     '& .slider-wrapper': { height: '100% !important', width: '100% !important' },
//     '& .slider': { height: '100% !important', width: '100% !important' },
//     '& .slide': { height: '100% !important', minWidth: '100% !important' },
//     '& .slide > div': { 
//       height: '100% !important', 
//       width: '100% !important',
//       position: 'relative !important',  // ✅ THIS was missing — fixes blur layer
//     },
//   }}
// >
//   {images.length > 1 ? (
//     <Carousel
//       selectedItem={images.indexOf(selectedImage)}
//       showThumbs={false}
//       showArrows={false}
//       autoPlay
//       infiniteLoop
//       interval={3000}
//       showIndicators
//       showStatus={false}
//       swipeable
//       emulateTouch
//       stopOnHover
//       transitionTime={600}
//       useKeyboardArrows
//     >
//     {images.map((image, index) => (
//   <Box
//     key={index}
//     sx={{
//       width: '100%',
//       height: '200px',
//       position: 'relative',
//       overflow: 'hidden',
//       display: 'block',
//     }}
//   >
//     {/* Blurred background */}
//     <Box
//       component="img"
//       src={image}
//       aria-hidden="true"
//       sx={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%) scale(1.3)',
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//         filter: 'blur(16px)',
//         opacity: 0.7,
//         zIndex: 0,
//       }}
//     />

//     {/* Main image */}
//     <Box
//       component="img"
//       src={image}
//       alt="Property"
//       loading="lazy"
//       sx={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         width: '100%',
//         height: '100%',
//         objectFit: 'contain',
//         zIndex: 1,
//       }}
//     />

//     {/* ✅ ADD THIS WATERMARK */}
//     <Box
//       sx={{
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         pointerEvents: 'none',
//         zIndex: 2,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//       }}
//     >
//       <Typography
//         sx={{
//           textAlign: 'center',
//           fontSize: '12px',
//           fontWeight: 'bold',
//           color: 'rgba(255, 255, 255, 0.54)',
//           whiteSpace: 'nowrap',
//         }}
//       >
//         PROPERTY PINCODER
//       </Typography>
//     </Box>
//   </Box>
// ))}
//     </Carousel>
//   ) : (
//     <Box
//       sx={{
//         width: '100%',
//         height: '200px',
//         position: 'relative',
//         overflow: 'hidden',
//         borderTopLeftRadius: '20px',
//         borderTopRightRadius: '20px',
//       }}
//     >
//       {/* ✅ Blurred background */}
//       <Box
//         component="img"
//         src={images[0]}
//         aria-hidden="true"
//         sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%) scale(1.3)',
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover',
//           filter: 'blur(16px)',
//           opacity: 0.7,
//           zIndex: 0,
//         }}
//       />
//       {/* ✅ Main image */}
//       <Box
//         component="img"
//         src={images[0]}
//         alt="Property"
//         loading="lazy"
//         sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: '100%',
//           height: '100%',
//           objectFit: 'contain',
//           zIndex: 1,
//         }}
//       />
//       {/* ✅ Watermark Overlay */}
// <Box
//   sx={{
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     pointerEvents: 'none',
//     zIndex: 2,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   }}
// >
//   <Typography
//     sx={{
//       position: 'absolute',
//    textAlign:'center',
//       fontSize: '12px',
//       fontWeight: 'bold',
//       color: 'rgba(255, 255, 255, 0.54)', // 👈 transparent
//       whiteSpace: 'nowrap',
//     }}
//   >
//     PROPERTY PINCODER
//   </Typography>


// </Box>
//     </Box>
//   )}
// </Box>
//   {/* ================= THUMBNAILS (FIXED) ================= */}
//   <Container sx={{ mt: 3 }}>
//     <Box
//       sx={{
//         display: 'flex',
//         padding:'2%',
//         overflowX: 'auto',
//         gap: 2,
//         pb: 1,
//         '&::-webkit-scrollbar': { display: 'none' },
//         scrollbarWidth: 'none',
//         msOverflowStyle: 'none',
//       }}
//     >
//       {images.map((image, index) => (
//         <Box
//           key={index}
//           onClick={() => handleImageClick(image)}
//           sx={{
//             width: '30%',
//             minWidth: '30%',
//             aspectRatio: '4 / 3',
//             borderRadius: '12px',
//             overflow: 'hidden',
//             position: 'relative',
//             cursor: 'pointer',
//             boxShadow:
//               selectedImage === image
//                 ? '0px 4px 20px rgba(0,0,0,0.3)'
//                 : '0px 2px 8px rgba(0,0,0,0.1)',
//             transform: selectedImage === image ? 'scale(1.02)' : 'scale(1)',
//             transition: 'all 0.4s ease',
//             border:
//               selectedImage === image
//                 ? '2px solid #1976d2'
//                 : '2px solid transparent',
//             flexShrink: 0,
//           }}
//         >
//           <Box
//             component="img"
//             src={image}
//             alt={`Thumbnail ${index + 1}`}
//             loading="lazy"
//             sx={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//             }}
//           />
//         </Box>
//       ))}
//     </Box>
//   </Container>

//             <CardContent>
//                     <Typography fontWeight="bold" fontSize="18px">
//                                  {categoryName?.replace(/"/g, '')} - {property.property_name || 'Property Type'} - PROP{property.id || propertyId}
//                                </Typography>
// <Grid
//   item
//   sx={{
//     display: 'flex',
//     flexDirection: 'column',
//     mt: 1,
//     gap: 0.5,
//     mb:0.3
//   }}
// >
//   {/* TOP ROW */}
// <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' ,mb:'5px'}}>
  
//   {/* LEFT: Call Icon */}
//   <Box sx={{ width: 32, display: 'flex', alignItems: 'center' }}>
//     <Tooltip title="Copy mobile number">
//         <IconButton
//               size="small"
//               onClick={() => handleCopyMobile(property.mobile_no)}
//               sx={{
//                 color: 'success.main',
//                 p: 0, // remove extra padding
//                  gap: '4px',
//                 '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' },
//               }}
//             >
//               <CallIcon sx={{ fontSize: '19px' }} />
//                <span style={{ fontSize: '14px' }}>Call</span>
//             </IconButton>
//     </Tooltip>
//   </Box>


// <Typography
//   fontWeight="bold"
//   fontSize="12px"
//   color="rgb(240, 65, 30)"
//   sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}
// >
//   {property.price ? (
//     <>
//       <span style={{ fontSize: '15px', marginRight: '2px' }}>₹</span>

//       <span>
//         {property.price.toLocaleString('en-IN')}
//       </span>
//     </>
//   ) : (
//     'NA'
//   )}
// </Typography>
// </Box>

// {/* BOTTOM ROW */}
// <Typography
//   variant="caption"
//   color="text.secondary"
//   sx={{
//     display: 'flex',
//     alignItems: 'flex-start',
//     gap: 0.2,
//   }}
// >
//   <Box sx={{ width: 32, display: 'flex', alignItems: 'flex-start' }}>
//     {loadingLocation ? (
//       <CircularProgress size={14} />
//     ) : (
//       <LocationOnIcon
//         onClick={handleLocationClick}
//         sx={{
//           fontSize: '18px',
//           color: 'primary.main',
//           cursor: 'pointer',
//         }}
//       />
//     )}
//   </Box>

//   <span>
//     {property.location || 'Not Specified'}
//   </span>
// </Typography>



// </Grid>

//   <Box sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               bgcolor: '#ede7f6',
//               borderRadius: 2,
//               p: 2,
//               mb: 2,
//             }}>
//   <Box sx={{ textAlign: 'center', flex: 1 }}>
//   <Typography fontWeight="bold" color="primary">
//     {property.site_area || property.max_acres
//       ? (() => {
//           const value = property.site_area || property.max_acres;
//           const unitRaw = property.units || '';
//           const unit = unitRaw.toLowerCase();

//           // Acres & Gunta → show as it is
//           if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
//             return `${value} ${unitRaw}`;
//           }

//           // Other units → add "Sq" before unit
//           return `${value}  ${unitRaw || 'ft'}`;
//         })()
//       : 'NA'}
//   </Typography>

//   <Typography variant="caption" color="text.secondary">
//     Site Area
//   </Typography>
// </Box>
//               <Box sx={{ textAlign: 'center', flex: 1 }}>
//                 <Typography fontWeight="bold" color="primary">
//                   {property.roadwidth || 'NA'} ft
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Road Width
//                 </Typography>
//               </Box>
//               <Box sx={{ textAlign: 'center', flex: 1 }}>
//                 <Typography fontWeight="bold" color="primary">
//                   {property.facing?.replace(/"/g, '') || 'NA'}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Facing
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Nearby
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
//               Nearby:
//             </Typography>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
//               <Chip
//                 label={nearby?.replace(/"/g, '') || 'Not Available'}
//                 sx={{
//                   bgcolor: 'rgb(211, 135, 173)',
//                   color: 'rgb(35, 35, 36)',
//                   fontWeight: 'bold',
//                   fontSize: '13px',
//                 }}
//               />
//             </Box> */}
// <AddPropertyCards />  

//             {/* Overview */}
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
//               Overview:
//             </Typography>
           
//             <Box sx={{
//   border: '2px solid #424242',
//   borderRadius: 2,
//   overflow: 'hidden',
// }}>
//   {[
//     [
//       // { icon: <BedIcon fontSize="small" />, title: `${bedrooms_count || '2'} Bedroom${bedrooms_count !== 1 ? 's' : ''}`, },
//       { icon: <AccessTimeIcon fontSize="small" />, title: 'Immediately', subtitle: 'Available From' },
//       { icon: <CalendarTodayIcon fontSize="small" />, title: created_at ? new Date(created_at).toLocaleDateString('en-IN') : 'NA', subtitle: 'Posted on' },
//     ],
//     // [
//     //   { icon: <BathtubIcon fontSize="small" />, title: `${bathrooms_count || '3'} Bathroom${bathrooms_count !== 1 ? 's' : ''}`,  },
//     //   { icon: <AccessTimeIcon fontSize="small" />, title: 'Immediately', subtitle: 'Available From' },
//     // ],
//     // [
//     //   { icon: <BalconyIcon fontSize="small" />, title: balcony ? 'Available' : 'Yes', subtitle: 'Balcony' },
//     //   { icon: <HomeWorkIcon fontSize="small" />, title: type?.replace(/"/g, '') || 'NA', subtitle: 'Property Type' },
//     // ],
//     // [
//     //   { icon: <DirectionsCarIcon fontSize="small" />, title: parking ? 'Available' : 'NA', subtitle: 'Parking' },
//     //   { icon: <PowerIcon fontSize="small" />, title: 'None', subtitle: 'Power Backup' },
//     // ],
//   ].map((row, rowIndex) => (
//     <Box key={rowIndex} sx={{ display: 'flex', width: '100%' }}>
//       {row.map((item, colIndex) => (
//         <Box
//           key={colIndex}
//           sx={{
//             flex: '0 0 50%',
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//             p: 1.5, // Slightly reduced padding
//             boxSizing: 'border-box',
//             borderRight: colIndex == 0 ? '1px solid #9e9e9e' : 'none',
//             borderBottom: rowIndex < 3 ? '1px solid #9e9e9e' : 'none',
//             minWidth: 0,
//           }}
//         >
//           <Box sx={{ 
//             color: 'rgb(50, 47, 52)', 
//             flexShrink: 0,
//             display: 'flex',
//             alignItems: 'center',
//           }}>
//             {item.icon}
//           </Box>
//           <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
//             <Typography 
//               fontWeight={500} // Slightly reduced weight
//               fontSize="0.875rem" // 14px instead of 15px
//               sx={{ 
//                 whiteSpace: 'normal', 
//                 wordBreak: 'break-word',
//                 lineHeight: 1.3
//               }}
//             >
//               {item.title}
//             </Typography>
//             <Typography 
//               variant="caption" 
//               color="text.secondary" 
//               fontSize="0.75rem" // 12px
//               sx={{ 
//                 whiteSpace: 'normal', 
//                 wordBreak: 'break-word',
//                 lineHeight: 1.3
//               }}
//             >
//               {item.subtitle}
//             </Typography>
//           </Box>
//         </Box>
//       ))}
//     </Box>
//   ))}
// </Box>
//             {/* Final Info */}
//             <Box sx={{ mt: 3, borderTop: '1px dashed #d1c4e9', pt: 2 }}>
//               {[
//                 ['Built Up Area', `${buildup_area || 'NA'} Sq.ft`, <CropSquareOutlinedIcon />],
//                 ['No.of Cars Parking', parking?.replace(/"/g, '') || 'NA', <DirectionsCarIcon />],
//                 ['Floor', `${no_of_flores || 'NA'}`, <LayersOutlinedIcon />],
//                 // ['Gated Security', 'No', <SecurityOutlinedIcon />],
//               ].map(([label, value, icon], i) => (
//                 <Box
//                   key={i}
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     mb: i !== 3 ? 1.5 : 0,
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', color: 'rgb(52, 50, 53)' }}>
//                     {icon}
//                     <Typography fontSize={14} sx={{ ml: 1 }} color="text.primary">
//                       {label}
//                     </Typography>
//                   </Box>
//                   <Typography fontWeight={500} color="text.primary" fontSize={14}>
//                     {value}
//                   </Typography>
//                 </Box>
//               ))}

//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           mt: 2
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <CropSquareOutlinedIcon sx={{ color: "#444" }} />
//           <Typography sx={{ fontSize: "0.9rem" }}>
//             Length*Width
//           </Typography>
//         </Box>
//        <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
//         {property.length && property.width
//           ? (() => {
//               const unitRaw = property.units || "";
//               const unit = unitRaw.toLowerCase();
      
//               // Acres / Gunta → as it is
//               if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
//                 return `${property.length} * ${property.width} ${unitRaw}`;
//               }
      
//               // Others → add Sq before unit
//               return `${property.length} * ${property.width} Sq ${unitRaw || 'ft'}`;
//             })()
//           : "NA"}
//       </Typography>
//       </Box>
      
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           mt: 2
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <SecurityOutlinedIcon sx={{ color: "#444" }} />
//           <Typography sx={{ fontSize: "0.9rem" }}>
//             Average Price
//           </Typography> 
//         </Box>
//      <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
//   {property.price
//     ? (() => {
//         let area = 0;

//         // ✅ Commercial buildings / apartments
//         if (property.buildup_area) {
//           area = parseFloat(property.buildup_area);

//           const floors = parseInt(
//             property.no_of_flores || property.floor || 0
//           );

//           // Multiply by floors only if positive
//           if (floors > 0) {
//             area = area * floors;
//           }
//         }
//         // ✅ Land properties
//         else if (property.site_area || property.max_acres) {
//           area = parseFloat(
//             property.site_area || property.max_acres
//           );
//         }

//         if (!area || area <= 0) return "NA";

//         const avgPrice =
//           parseFloat(property.price) / area;

//         const unitRaw = property.units || "";
//         const unit = unitRaw.toLowerCase();

//         // Acres / Guntas
//         if (
//           ["acre", "acres", "gunta", "guntas"].includes(unit)
//         ) {
//           return `₹${avgPrice.toFixed(2)} / ${unitRaw}`;
//         }

//         const hasSq = unit.includes("sq");

//         return `₹${avgPrice.toFixed(2)} / ${
//           hasSq ? unitRaw : `Sq ${unitRaw || "ft"}`
//         }`;
//       })()
//     : "NA"}
// </Typography>
//       </Box>  
//             </Box>
//             <Box
//   sx={{
//     mt: 3,
//     p: 2.5,
//     bgcolor: '#f5f5f5',
//     borderRadius: 2,
//     border: '1px solid #e0e0e0',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.05'
//   }}
// >
//   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
//     <DescriptionIcon sx={{ color: '#1976d2', fontSize: 22 }} />
//     <Typography
//       variant="subtitle1"
//       fontWeight="bold"
//       sx={{ fontSize: '1rem', color: '#333' }}
//     >
//       Description
//     </Typography>
//   </Box>

//   <Typography
//     variant="body2"
//     color="text.secondary"
//     sx={{
//       whiteSpace: 'pre-wrap',
//       wordBreak: 'break-word',
//       lineHeight: 1.8,
//       fontSize: '0.9rem',
//       color: '#555'
//     }}
//   >
//     {property.description?.trim()
//       ? property.description
//       : 'No description available.'}
//   </Typography>
// </Box>
//           </CardContent>
//         </Card>
//       </Box>

//       {showSubscribeModal && (
//               <Box sx={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0,0,0,0.5)',
//                 zIndex: 9999,
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center'
//               }}>
//                 <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
//                   <Typography variant="h6" gutterBottom>
//                     Subscription Required
//                   </Typography>
//                   <Typography variant="body1" sx={{ mb: 2 }}>
//                     Please subscribe to use the {featureRequested} feature.
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="primary"
//                     onClick={() => setShowSubscribeModal(false)}
//                   >
//                     OK
//                   </Button>
//                 </Paper>
//               </Box>
//             )}

  
// {/* Limit Exceeded Modal */}
// {showLimitModal && (
//   <Box sx={{
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(0,0,0,0.5)',
//     zIndex: 9999,
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center'
//   }}>
//     <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
//       <Typography variant="h6" gutterBottom>
//         Limit Exceeded
//       </Typography>
//       <Typography variant="body1" sx={{ mb: 2 }}>
//         {userPlan?.no_of_properties_unlimited 
//           ? "You have unlimited access to properties."
//           : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. 
//              Please upgrade your subscription plan for more.`
//         }
//       </Typography>
//       <Button 
//         variant="contained" 
//         color="primary"
//         onClick={() => setShowLimitModal(false)}
//       >
//         OK
//       </Button>
//     </Paper>
//   </Box>
// )}

// {showSuccess && (
//   <CopySuccessAlert
//     message={alertMessage}
//     onClose={() => {
//       setShowSuccess(false);
//       setAlertMessage(""); // Clear message when closing
//     }}
//   />
// )}

// {showFailure && (
//   <CopyFailureAlert
//     message={alertMessage}
//     onClose={() => {
//       console.log("Closing failure alert");
//       setShowFailure(false);
//       setAlertMessage("");
//     }}
//   />
// )}
//       {/* Bottom Navigation */}
//       <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
//         <CustomBottomNav />
//       </Paper>
//     </Box>
//   );
// };

// export default Rent_description;

// import React, { useEffect, useState, useContext } from 'react';
// import {
//   Box, Typography, IconButton, Paper, Button, CircularProgress,
//   Accordion, AccordionSummary, AccordionDetails, Tooltip
// } from '@mui/material';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import BedIcon from '@mui/icons-material/Bed';
// import ElevatorIcon from '@mui/icons-material/Elevator';
// import HomeWorkIcon from '@mui/icons-material/HomeWork';
// import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
// import OpacityIcon from '@mui/icons-material/Opacity';
// import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
// import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
// import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
// import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomBottomNav from './BottomNavbar/BottomNavbar';
// import { BASE_URL } from './../../Api/ApiUrls';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import CallIcon from '@mui/icons-material/Call';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import DescriptionIcon from '@mui/icons-material/Description';
// import AddPropertyCards from '../AddsProducts/RentDescriptionCard';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import HomeIcon from '@mui/icons-material/Home';
// import EventAvailableIcon from '@mui/icons-material/EventAvailable';
// import GroupIcon from '@mui/icons-material/Group';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import StraightenIcon from '@mui/icons-material/Straighten';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import TodayIcon from '@mui/icons-material/Today';

// const Rent_description = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { propertyId: paramPropertyId } = useParams();
//   const { userId, logout } = useContext(AuthContext);

//   const { propertyId: statePropertyId } = location.state || {};
//   const propertyId = statePropertyId || paramPropertyId;

//   const [loadingLocation, setLoadingLocation] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [property, setProperty] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(0);
//   const [isSubscribed, setIsSubscribed] = useState(false);
//   const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//   const [featureRequested, setFeatureRequested] = useState('');
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);
//   const [showLimitModal, setShowLimitModal] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [detailsExpanded, setDetailsExpanded] = useState(true);

//   const handleCopyMobile = (mobile) => {
//     if (!mobile || mobile.trim() === '') {
//       setAlertMessage("Mobile number not available");
//       setShowFailure(true);
//       return;
//     }
//     navigator.clipboard.writeText(mobile)
//       .then(() => {
//         setAlertMessage(`Mobile number copied: ${mobile}`);
//         setShowSuccess(true);
//       })
//       .catch((err) => {
//         console.error("Copy failed:", err);
//         setAlertMessage("Failed to copy mobile number");
//         setShowFailure(true);
//       });
//   };

//   // ✅ NEW: Indian date format helper
//   const formatIndianDate = (dateString) => {
//     if (!dateString) return 'NA';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleString('en-IN', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//         hour12: true,
//       });
//     } catch {
//       return 'NA';
//     }
//   };

//   const handleImageClick = (image) => setSelectedImage(image);

//   // ===== SUBSCRIPTION CHECK (TENANT) =====
//   useEffect(() => {
//     const checkSubscription = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
//         const userSubscriptions = response.data;
//         const hasTenantSubscription = Array.isArray(userSubscriptions) &&
//           userSubscriptions.some(sub => sub.user_type === "Tenant");
//         setIsSubscribed(hasTenantSubscription);
//       } catch (error) {
//         console.error('Error checking subscription:', error);
//         setIsSubscribed(false);
//       }
//     };
//     if (userId) checkSubscription();
//     else setIsSubscribed(false);
//   }, [userId]);

//   // ===== USER ACTIVITIES =====
//   useEffect(() => {
//     const fetchUserActivities = async () => {
//       if (!userId) return;
//       try {
//         const response = await fetch(`${BASE_URL}/activities/`);
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         const allActivities = await response.json();
//         const filteredActivities = allActivities.filter(activity =>
//           activity && activity.user_id !== undefined && String(activity.user_id) === String(userId)
//         );
//         setUserActivities(filteredActivities);
//       } catch (error) {
//         console.error('Error fetching activities:', error);
//         setUserActivities([]);
//       }
//     };
//     fetchUserActivities();
//   }, [userId]);

//   const checkPropertyLimit = (currentPropertyId) => {
//     if (!isSubscribed) {
//       setFeatureRequested("Property Access");
//       setShowSubscribeModal(true);
//       return false;
//     }
//     if (userPlan?.no_of_properties_unlimited) return true;
//     const uniqueProperties = new Set(userActivities.map(a => a.property_id));
//     const isExistingProperty = uniqueProperties.has(currentPropertyId);
//     const propertyLimit = userPlan?.no_of_properties || 10;
//     if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   };

//   // ===== FIELD MAP (RENT) =====
//   const fieldMap = {
//     'Commercial land/plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
//     'Plot/land': ['Site Area', 'Facing', 'Price', 'Road Width'],
//     'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms', 'Lift', 'Road Width'],
//     'Duplex house': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms', 'Lift', 'Road Width'],
//     'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count', 'Lift', 'Road Width'],
//     'Pg-offices': ['Property Name', 'Site Area', 'Facing', 'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
//     'Flat': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
//     'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
//     'Commercial building': ['Property Name', 'Site Area', 'Facing', 'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
//     'Apartment': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
//     'JV/JD': ['Site Area', 'Facing', 'Price', 'Road Width'],
//   };

//   const images = property?.property_images && property.property_images.length > 0
//     ? property.property_images.map(img => `${BASE_URL}${img.image}`)
//     : [buildingImage];

//   // ===== LOCATION HANDLER =====
//   const handleLocationClick = async () => {
//     if (!isSubscribed) {
//       setFeatureRequested("Location Access");
//       setShowSubscribeModal(true);
//       return;
//     }
//     if (!checkPropertyLimit(property.id)) return;

//     setLoadingLocation(true);

//     const logActivity = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/activities/`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             user_id: userId,
//             property_id: property.id,
//             activity_type: "Location",
//             property_by: property.owner,
//             activity_as: "Tenant"
//           })
//         });
//         if (!response.ok) throw new Error('Failed to log location activity');
//         const newActivity = await response.json();
//         setUserActivities(prev => [...prev, newActivity]);
//       } catch (err) {
//         console.error("Error logging location activity:", err);
//       }
//     };

//     const openLocation = () => {
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const userLat = position.coords.latitude;
//             const userLong = position.coords.longitude;
//             if (property?.lat && property?.long) {
//               window.open(`https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLong}&destination=${property.lat},${property.long}`, '_blank');
//             } else if (property?.loc || property?.location) {
//               window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc || property.location)}`, '_blank');
//             }
//             setLoadingLocation(false);
//           },
//           () => {
//             if (property?.lat && property?.long) {
//               window.open(`https://www.google.com/maps/?q=${property.lat},${property.long}`, '_blank');
//             }
//             setLoadingLocation(false);
//           }
//         );
//       } else {
//         setLoadingLocation(false);
//       }
//     };

//     await logActivity();
//     openLocation();
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
//         setCategories(categoriesRes.data);
//         if (propertyId) {
//           const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
//           setProperty(propertyRes.data);
//         }
//       } catch (err) {
//         console.error('Failed to fetch data:', err);
//       }
//     };
//     fetchData();
//   }, [propertyId]);

//   if (!property) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <Typography>Loading property...</Typography>
//       </Box>
//     );
//   }

//   const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
//   const categoryName = propertyCategory ? propertyCategory.category : property.type;

//   const fieldsToDisplay = fieldMap[categoryName] || [];
//   const excludedDisplayFields = ['Site Area', 'Facing', 'Price', 'Road Width', 'No.of Floors', 'Buildup Area'];

//   const propertyDetails = fieldsToDisplay.map((field) => {
//     switch (field) {
//       case 'Site Area': return { label: 'Site Area', value: `${property.site_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
//       case 'Facing': return { label: 'Facing', value: property.facing?.replace(/"/g, '') || 'NA', icon: <CompassCalibrationOutlinedIcon /> };
//       case 'Price': return { label: 'Price', value: property.price ? property.price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }) : 'NA', icon: <SecurityOutlinedIcon /> };
//       case 'Road Width': return { label: 'Road Width', value: `${property.roadwidth || 'NA'} ft`, icon: <CropSquareOutlinedIcon /> };
//       case 'No.of Floors': return { label: 'No. of Floors', value: `${property.no_of_flores || 'NA'}`, icon: <LayersOutlinedIcon /> };
//       case 'Buildup Area': return { label: 'Buildup Area', value: `${property.buildup_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
//       case 'Borewell': return { label: 'Bore Well', value: property.borewell === 'Yes' ? 'Available' : 'Not Available', icon: <OpacityIcon /> };
//       case 'No.of Cars Parking': return { label: 'Parking', value: `${property.parking || 'NA'}`, icon: <DirectionsCarIcon /> };
//       case '1bhk Count': return { label: '1 BHK', value: property._1bhk_count ? `${property._1bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case '2bhk Count': return { label: '2 BHK', value: property._2bhk_count ? `${property._2bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case '3bhk Count': return { label: '3 BHK', value: property._3bhk_count ? `${property._3bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case '4bhk Count': return { label: '4 BHK', value: property._4bhk_count ? `${property._4bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case 'Duplex Bedrooms': return { label: 'Duplex BHK', value: property.duplex_bedrooms || 'NA', icon: <BedIcon /> };
//       case 'Lift': return { label: 'Lift', value: property.lift === 'Yes' ? 'Available' : 'Not Available', icon: <ElevatorIcon /> };
//       case 'House Count': return { label: 'House Count', value: property.house_count ? `${property.house_count} No's` : 'NA', icon: <HomeWorkIcon /> };
//       default: return null;
//     }
//   }).filter(detail => detail !== null && !excludedDisplayFields.includes(detail.label));

//   const groupedPropertyDetails = [];
//   for (let i = 0; i < propertyDetails.length; i += 2) {
//     groupedPropertyDetails.push(propertyDetails.slice(i, i + 2));
//   }

//   // ===== HIGHLIGHTS DATA (RENT) =====
//   const highlightsData = [
//     { icon: <BedIcon />, value: `${property.duplex_bedrooms || property._1bhk_count || property._2bhk_count || property._3bhk_count || '3'} BHK`, label: '(Duplex)' },
//     { icon: <DirectionsCarIcon />, value: `${property.parking || '3'} Cars`, label: '(Covered + Open)' },
//     { icon: <HomeWorkIcon />, value: `${property.buildup_area || '2400'} Sq.ft`, label: '(Per Floor)' },
//     { icon: <AccountBalanceWalletIcon />, value: `₹ ${property.price ? property.price.toLocaleString('en-IN') : 'NA'}`, label: '(Monthly Rent)' },
//     { icon: <CheckCircleOutlineIcon />, value: 'Lift, Power Backup', label: 'Security, CCTV, GST' },
//     { icon: <GroupIcon />, value: '100%', label: '(Occupied)' },
//     { icon: <EventAvailableIcon />, value: 'Immediate', label: 'Available For' },
//   ];

//   const groupedHighlights = [];
//   for (let i = 0; i < highlightsData.length; i += 2) {
//     groupedHighlights.push(highlightsData.slice(i, i + 2));
//   }

//   return (
//     <Box sx={{ width: '100vw', minHeight: '100vh', backgroundColor: '#F8F3EC', pb: 8 }}>

//       {/* ===== HEADER ===== */}
//       <Box sx={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10,
//         bgcolor: '#3E2A1E', color: 'white',
//         px: 2, py: 1.5, display: 'flex', alignItems: 'center',
//       }}>
//         <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1, p: 0.5 }}>
//           <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
//         </IconButton>
//         <Typography sx={{ flex: 1, fontSize: '1rem', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//           {categoryName?.replace(/"/g, '') || 'Property'}
//         </Typography>
//       </Box>

//       <Box sx={{ pt: '60px' }}>

//         {/* ===== MAIN IMAGE ===== */}
//         <Box sx={{ position: 'relative', width: '100%', height: 260, overflow: 'hidden', bgcolor: '#000' }}>
//           <Carousel
//             selectedItem={images.indexOf(selectedImage)}
//             showThumbs={false} showArrows={false} autoPlay infiniteLoop interval={3000}
//             showIndicators={false} showStatus={false} swipeable emulateTouch
//             stopOnHover transitionTime={600} useKeyboardArrows
//           >
//             {images.map((image, index) => (
//               <Box key={index} sx={{ width: '100%', height: 260, position: 'relative', overflow: 'hidden' }}>
//                 <Box component="img" src={image} aria-hidden="true" sx={{
//                   position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) scale(1.3)',
//                   width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(16px)', opacity: 0.7, zIndex: 0,
//                 }} />
//                 <Box component="img" src={image} alt="Property" loading="lazy" sx={{
//                   position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                   width: '100%', height: '100%', objectFit: 'contain', zIndex: 1,
//                 }} />
//                 <Box sx={{
//                   position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
//                   pointerEvents: 'none', zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 }}>
//                   <Typography sx={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', color: 'rgba(255, 255, 255, 0.54)', whiteSpace: 'nowrap' }}>
//                     PROPERTY PINCODER
//                   </Typography>
//                 </Box>
//               </Box>
//             ))}
//           </Carousel>

//           <Box sx={{
//             position: 'absolute', bottom: 10, right: 10, zIndex: 5,
//             bgcolor: 'rgba(0,0,0,0.6)', color: 'white',
//             px: 1.2, py: 0.3, borderRadius: '20px',
//             display: 'flex', alignItems: 'center', gap: 0.5,
//           }}>
//             <Box component="span" sx={{ fontSize: '0.7rem' }}>📷</Box>
//             <Typography sx={{ fontSize: '0.7rem', fontWeight: 600 }}>1/{images.length}</Typography>
//           </Box>
//         </Box>

//         {/* ===== THUMBNAILS ===== */}
//         <Box sx={{
//           display: 'flex', overflowX: 'auto', gap: 1, px: 1.5, py: 1.5,
//           '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none', msOverflowStyle: 'none',
//         }}>
//           {images.map((image, index) => (
//             <Box key={index} onClick={() => handleImageClick(image)} sx={{
//               width: 90, minWidth: 90, height: 60, borderRadius: '8px', overflow: 'hidden',
//               cursor: 'pointer', flexShrink: 0,
//               border: selectedImage === image ? '2px solid #8A6A3D' : '2px solid transparent',
//               transition: 'all 0.2s ease',
//             }}>
//               <Box component="img" src={image} alt={`Thumb ${index + 1}`} loading="lazy"
//                 sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//             </Box>
//           ))}
//           {images.length > 3 && (
//             <Box sx={{
//               width: 90, minWidth: 90, height: 60, borderRadius: '8px',
//               bgcolor: '#3E2A1E', color: 'white',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               fontSize: '0.8rem', fontWeight: 600, flexShrink: 0,
//             }}>
//               +{images.length - 3}
//             </Box>
//           )}
//         </Box>

//         {/* ===== TITLE & PRICE ===== */}
//         <Box sx={{ px: 1, mb: 1 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
//             <Typography sx={{ flex: 1, fontSize: '1.05rem', fontWeight: 700, color: '#222', lineHeight: 1.3 }}>
//               {categoryName?.replace(/"/g, '')} {property.property_name ? `- ${property.property_name}` : ''}
//             </Typography>
//             <Box sx={{
//               bgcolor: '#F5DEB3', color: '#5C3D1E',
//               px: 1.2, py: 0.5, borderRadius: '8px',
//               fontSize: '0.9rem', fontWeight: 700, whiteSpace: 'nowrap',
//               border: '1px solid #E8C99A',
//             }}>
//               ₹ {property.price ? property.price.toLocaleString('en-IN') : 'NA'}
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== PROPERTY ID, CALL & LOCATION ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           {/* Row 1: Property ID | Call | Location Icon - all in one row */}
//           <Box sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//             mb: 0.8,
//             flexWrap: 'nowrap'
//           }}>

//             {/* Property ID Box */}
//             <Box sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 0.5,
//               bgcolor: '#F5DEB3',
//               border: '1px solid #E8C99A',
//               borderRadius: '8px',
//               px: 1,
//               py: 0.5,
//               flex: 1,
//               minWidth: 0,
//             }}>
//               <Typography sx={{
//                 fontSize: '0.75rem',
//                 color: '#5C3D1E',
//                 fontWeight: 600,
//                 whiteSpace: 'nowrap'
//               }}>
//                 Property Id :
//               </Typography>
//               <Typography sx={{
//                 fontSize: '0.75rem',
//                 color: '#5C3D1E',
//                 fontWeight: 700,
//                 whiteSpace: 'nowrap',
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis'
//               }}>
//                 {property.id || propertyId}
//               </Typography>
//             </Box>

//             {/* Call Box */}
//             <Tooltip title="Copy mobile number">
//               <Box
//                 onClick={() => handleCopyMobile(property.mobile_no)}
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 0.5,
//                   cursor: 'pointer',
//                   color: '#2E7D32',
//                   bgcolor: '#E8F5E9',
//                   border: '1px solid #A5D6A7',
//                   borderRadius: '8px',
//                   px: 1,
//                   py: 0.5,
//                   whiteSpace: 'nowrap',
//                 }}
//               >
//                 <CallIcon sx={{ fontSize: 18 }} />
//                 <Typography sx={{ fontSize: '0.8rem', fontWeight: 600 }}>Contact</Typography>
//               </Box>
//             </Tooltip>

//             {/* Location Icon Box */}
//             <Box sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               bgcolor: '#E8F5E9',
//               border: '1px solid #A5D6A7',
//               borderRadius: '8px',
//               px: 1,
//               py: 0.5,
//               cursor: 'pointer',
//             }}>
//               {loadingLocation ? (
//                 <CircularProgress size={18} sx={{ color: '#2E7D32' }} />
//               ) : (
//                 <LocationOnIcon
//                   onClick={handleLocationClick}
//                   sx={{ fontSize: 18, color: '#2E7D32' }}
//                 />
//               )}
//             </Box>
//           </Box>

//           {/* Row 2: Location text (as before) */}
//           <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}>
//             <Typography sx={{ fontSize: '0.8rem', color: '#555', lineHeight: 1.4 }}>
//               {property.location || 'Not Specified'}
//             </Typography>
//           </Box>
//         </Box>

//         {/* ===== SITE AREA / ROAD WIDTH / FACING ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Box sx={{
//             display: 'flex', justifyContent: 'space-between',
//             bgcolor: '#FBF5ED', border: '1px solid #E8DCC8',
//             borderRadius: '10px', p: 1.5,
//           }}>
//             <Box sx={{ textAlign: 'center', flex: 1 }}>
//               <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
//                 <HomeWorkIcon />
//               </Box>
//               <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
//                 {property.site_area || property.max_acres ? (() => {
//                   const value = property.site_area || property.max_acres;
//                   const unitRaw = property.units || '';
//                   const unit = unitRaw.toLowerCase();
//                   if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) return `${value} ${unitRaw}`;
//                   const hasSq = unit.includes('sq');
//                   return `${value} ${hasSq ? unitRaw : `Sq ${unitRaw || 'ft'}`}`;
//                 })() : 'NA'}
//               </Typography>
//               <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Site Area</Typography>
//             </Box>
//             <Box sx={{ width: '1px', bgcolor: '#E8DCC8' }} />
//             <Box sx={{ textAlign: 'center', flex: 1 }}>
//               <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
//                 <StraightenIcon />
//               </Box>
//               <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
//                 {property.roadwidth || 'NA'} ft
//               </Typography>
//               <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Road Width</Typography>
//             </Box>
//             <Box sx={{ width: '1px', bgcolor: '#E8DCC8' }} />
//             <Box sx={{ textAlign: 'center', flex: 1 }}>
//               <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
//                 <CompassCalibrationOutlinedIcon />
//               </Box>
//               <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
//                 {property.facing?.replace(/"/g, '') || 'NA'}
//               </Typography>
//               <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Facing</Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== PROPERTY HIGHLIGHTS ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Box sx={{
//             bgcolor: '#FFFFFF', border: '1px solid #E8DCC8',
//             borderRadius: '12px', p: 1.5,
//           }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <HomeIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                 <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
//                   Property Highlights
//                 </Typography>
//               </Box>
//               <Box sx={{
//                 bgcolor: '#F5DEB3', color: '#5C3D1E',
//                 px: 1, py: 0.2, borderRadius: '4px',
//                 fontSize: '0.7rem', fontWeight: 600,
//                 border: '1px solid #E8C99A',
//               }}>
//                 For Rent
//               </Box>
//             </Box>

//             <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 0.5 }}>
//               {groupedHighlights.map((row, rowIndex) => (
//                 <Box
//                   key={rowIndex}
//                   sx={{
//                     display: 'flex',
//                     width: '100%',
//                     borderBottom: rowIndex !== groupedHighlights.length - 1 ? '1px solid #F0E6D6' : 'none',
//                   }}
//                 >
//                   {row.map((item, colIndex) => (
//                     <Box
//                       key={colIndex}
//                       sx={{
//                         flex: '0 0 50%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1,
//                         py: 1.2,
//                         px: 0.5,
//                         boxSizing: 'border-box',
//                         borderRight: colIndex === 0 ? '1px solid #F0E6D6' : 'none',
//                         minWidth: 0,
//                       }}
//                     >
//                       <Box sx={{
//                         color: '#8A6A3D',
//                         flexShrink: 0,
//                         display: 'flex',
//                         alignItems: 'center',
//                         '& svg': { fontSize: 20 },
//                       }}>
//                         {item.icon}
//                       </Box>
//                       <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
//                         <Typography sx={{
//                           fontSize: '0.85rem',
//                           fontWeight: 600,
//                           color: '#222',
//                           lineHeight: 1.2,
//                           whiteSpace: 'normal',
//                           wordBreak: 'break-word',
//                         }}>
//                           {item.value}
//                         </Typography>
//                         <Typography sx={{
//                           fontSize: '0.7rem',
//                           color: '#777',
//                           lineHeight: 1.2,
//                           whiteSpace: 'normal',
//                           wordBreak: 'break-word',
//                         }}>
//                           {item.label}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                   {row.length === 1 && <Box sx={{ flex: '0 0 50%' }} />}
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== PROPERTY DETAILS (Collapsible) ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Accordion expanded={detailsExpanded} onChange={() => setDetailsExpanded(!detailsExpanded)}
//             sx={{
//               borderRadius: '12px !important', border: '1px solid #E8DCC8',
//               boxShadow: 'none', '&:before': { display: 'none' },
//               '&.Mui-expanded': { margin: 0 },
//             }}>
//             <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#8A6A3D' }} />}
//               sx={{ px: 1.5, minHeight: 48, '&.Mui-expanded': { minHeight: 48 } }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <ApartmentIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                 <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
//                   Property Details
//                 </Typography>
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
//               <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 1.5 }}>
//                 {groupedPropertyDetails.map((row, rowIndex) => (
//                   <Box key={rowIndex} sx={{ display: 'flex', width: '100%', borderBottom: rowIndex !== groupedPropertyDetails.length - 1 ? '1px solid #F0E6D6' : 'none' }}>
//                     {row.map((item, colIndex) => (
//                       <Box key={colIndex} sx={{
//                         flex: '0 0 50%', display: 'flex', alignItems: 'center', gap: 1,
//                         py: 1.2, px: 0.5, boxSizing: 'border-box',
//                         borderRight: colIndex === 0 ? '1px solid #F0E6D6' : 'none',
//                         minWidth: 0,
//                       }}>
//                         <Box sx={{ color: '#8A6A3D', flexShrink: 0, display: 'flex', alignItems: 'center', '& svg': { fontSize: 20 } }}>
//                           {item.icon}
//                         </Box>
//                         <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
//                           <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222', lineHeight: 1.2 }}>
//                             {item.value}
//                           </Typography>
//                           <Typography sx={{ fontSize: '0.7rem', color: '#777', lineHeight: 1.2 }}>
//                             {item.label}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     ))}
//                     {row.length === 1 && <Box sx={{ flex: '0 0 50%' }} />}
//                   </Box>
//                 ))}

//                 {/* Length * Width row */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <CropSquareOutlinedIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                     <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Length * Width</Typography>
//                   </Box>
//                   <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
//                     {property.length && property.width ? (() => {
//                       const unitRaw = property.units || "";
//                       const unit = unitRaw.toLowerCase();
//                       if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) return `${property.length} * ${property.width} ${unitRaw}`;
//                       return `${property.length} * ${property.width} Sq ${unitRaw || 'ft'}`;
//                     })() : "NA"}
//                   </Typography>
//                 </Box>

//                 {/* Average Price row */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <SecurityOutlinedIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                     <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Average Price</Typography>
//                   </Box>
//                   <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
//                     {property.price ? (() => {
//                       let area = 0;
//                       if (property.buildup_area) {
//                         area = parseFloat(property.buildup_area);
//                         const floors = parseInt(property.no_of_flores || property.floor || 0);
//                         if (floors > 0) area = area * floors;
//                       } else if (property.site_area || property.max_acres) {
//                         area = parseFloat(property.site_area || property.max_acres);
//                       }
//                       if (!area || area <= 0) return "NA";
//                       const avgPrice = parseFloat(property.price) / area;
//                       const unitRaw = property.units || "";
//                       const unit = unitRaw.toLowerCase();
//                       if (["acre", "acres", "gunta", "guntas"].includes(unit)) return `₹${avgPrice.toFixed(2)} / ${unitRaw}`;
//                       const hasSq = unit.includes("sq");
//                       return `₹${avgPrice.toFixed(2)} / ${hasSq ? unitRaw : `Sq ${unitRaw || "ft"}`}`;
//                     })() : "NA"}
//                   </Typography>
//                 </Box>

//                 {/* ✅ NEW: Posted On (Created At) row - LAST row */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <TodayIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                     <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Posted On</Typography>
//                   </Box>
//                   <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
//                     {formatIndianDate(property.created_at)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </AccordionDetails>
//           </Accordion>
//         </Box>

      

//         {/* ADDED COMPONENT */}
//         <AddPropertyCards />
//           {/* ===== DESCRIPTION ===== */}
//         <Box sx={{ px: 1, mb: 2 }}>
//           <Box sx={{
//             bgcolor: '#FFFFFF', border: '1px solid #E8DCC8',
//             borderRadius: '12px', p: 1.5,
//           }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 1 }}>
//               <DescriptionIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//               <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
//                 Description
//               </Typography>
//             </Box>
//             <Typography sx={{
//               fontSize: '0.8rem', color: '#555', lineHeight: 1.6,
//               whiteSpace: 'pre-wrap', wordBreak: 'break-word',
//             }}>
//               {property.description?.trim() ? property.description : 'No description available.'}
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* ===== MODALS & ALERTS ===== */}
//       {showSubscribeModal && (
//         <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center', borderRadius: 3 }}>
//             <Typography variant="h6" gutterBottom fontWeight="bold">Subscription Required</Typography>
//             <Typography variant="body2" sx={{ mb: 2 }}>Please subscribe to use the {featureRequested} feature.</Typography>
//             <Button variant="contained" onClick={() => setShowSubscribeModal(false)} sx={{ bgcolor: '#8A6A3D', '&:hover': { bgcolor: '#6d5230' } }}>OK</Button>
//           </Paper>
//         </Box>
//       )}

//       {showLimitModal && (
//         <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center', borderRadius: 3 }}>
//             <Typography variant="h6" gutterBottom fontWeight="bold">Limit Exceeded</Typography>
//             <Typography variant="body2" sx={{ mb: 2 }}>
//               {userPlan?.no_of_properties_unlimited ? "You have unlimited access to properties." : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. Please upgrade your subscription plan for more.`}
//             </Typography>
//             <Button variant="contained" onClick={() => setShowLimitModal(false)} sx={{ bgcolor: '#8A6A3D', '&:hover': { bgcolor: '#6d5230' } }}>OK</Button>
//           </Paper>
//         </Box>
//       )}

//       {showSuccess && <CopySuccessAlert message={alertMessage} onClose={() => { setShowSuccess(false); setAlertMessage(""); }} />}
//       {showFailure && <CopyFailureAlert message={alertMessage} onClose={() => { setShowFailure(false); setAlertMessage(""); }} />}

//       <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
//         <CustomBottomNav />
//       </Paper>
//     </Box>
//   );
// };

// export default Rent_description;



// // Rent_description.js
// import React, { useEffect, useState, useContext } from 'react';
// import {
//   Box, Typography, IconButton, Paper, Button, CircularProgress,
//   Accordion, AccordionSummary, AccordionDetails, Tooltip
// } from '@mui/material';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import BedIcon from '@mui/icons-material/Bed';
// import ElevatorIcon from '@mui/icons-material/Elevator';
// import HomeWorkIcon from '@mui/icons-material/HomeWork';
// import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
// import OpacityIcon from '@mui/icons-material/Opacity';
// import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
// import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
// import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
// import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomBottomNav from './BottomNavbar/BottomNavbar';
// import { BASE_URL } from './../../Api/ApiUrls';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import CallIcon from '@mui/icons-material/Call';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import DescriptionIcon from '@mui/icons-material/Description';
// import AddPropertyCards from '../AddsProducts/RentDescriptionCard';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import HomeIcon from '@mui/icons-material/Home';
// import EventAvailableIcon from '@mui/icons-material/EventAvailable';
// import GroupIcon from '@mui/icons-material/Group';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import StraightenIcon from '@mui/icons-material/Straighten';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import TodayIcon from '@mui/icons-material/Today';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import PersonIcon from '@mui/icons-material/Person';
// import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
// import Favorite from '@mui/icons-material/Favorite';
// import ShareIcon from '@mui/icons-material/Share';
// import GuestLoginModal from '../../GuestLoginModal';
// import WishlistSuccessAlert from '../Alertpage/CopyAlert/WishlistSuccessAlert';
// const Rent_description = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { propertyId: paramPropertyId } = useParams();
//   const { userId, isGuest } = useContext(AuthContext);

//   const { propertyId: statePropertyId } = location.state || {};
//   const propertyId = statePropertyId || paramPropertyId;

//   const [loadingLocation, setLoadingLocation] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [property, setProperty] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(0); // ✅ always an index
//   const [isSubscribed, setIsSubscribed] = useState(false);
//   const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//   const [featureRequested, setFeatureRequested] = useState('');
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);
//   const [showLimitModal, setShowLimitModal] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [detailsExpanded, setDetailsExpanded] = useState(true);

//   // ===== Description state =====
//   const [descriptionExpanded] = useState(true);
//   const [descriptionClampExpanded, setDescriptionClampExpanded] = useState(false);

//   // ===== Wishlist + Share state =====
//   const [isWishlisted, setIsWishlisted] = useState(false);
//   const [wishlistLoading, setWishlistLoading] = useState(false);
//   const [cartItemId, setCartItemId] = useState(null);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//  const [isWishlistRemoved, setIsWishlistRemoved] = useState(false);
 
//   const handleCopyMobile = (mobile) => {
//     if (!mobile || mobile.trim() === '') {
//       setAlertMessage("Mobile number not available");
//       setShowFailure(true);
//       return;
//     }
//     navigator.clipboard.writeText(mobile)
//       .then(() => {
//         setAlertMessage(`Mobile number copied: ${mobile}`);
//         setShowSuccess(true);
//       })
//       .catch((err) => {
//         console.error("Copy failed:", err);
//         setAlertMessage("Failed to copy mobile number");
//         setShowFailure(true);
//       });
//   };

//   // ─────────────────────────────────────────────────────────────
//   // Chat now click handler (Replaces WhatsApp)
//   // ─────────────────────────────────────────────────────────────
//   const handleChatNowClick = () => {
//     // Navigate to the chat route and pass the propertyId via state
//     navigate('/chat', {
//       state: { property: propertyId }
//     });
//   };

//   // ✅ Indian date format helper
//   const formatIndianDate = (dateString) => {
//     if (!dateString) return 'NA';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleString('en-IN', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//         hour12: true,
//       });
//     } catch {
//       return 'NA';
//     }
//   };

//   // ===== "time ago" helper (seller card) =====
//   const formatTimeAgo = (dateString) => {
//     if (!dateString) return '';
//     const now = new Date();
//     const then = new Date(dateString);
//     const diffMs = now - then;
//     const diffMins = Math.floor(diffMs / 60000);
//     const diffHours = Math.floor(diffMs / 3600000);
//     const diffDays = Math.floor(diffMs / 86400000);
//     const diffMonths = Math.floor(diffDays / 30);
//     const diffYears = Math.floor(diffDays / 365);

//     if (diffMins < 1) return 'just now';
//     if (diffMins < 60) return `${diffMins} min ago`;
//     if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
//     if (diffDays < 30) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
//     if (diffMonths < 12) return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
//     return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
//   };

//   const getSellerName = (p) => {
//     const first = p?.user_first_name?.trim();
//     const last = p?.user_last_name?.trim();
//     if (first || last) return `${first || ''} ${last || ''}`.trim();
//     return p?.posted_by || 'Owner';
//   };

//   // ✅ Now takes an index (not the URL string)
//   const handleImageClick = (index) => setSelectedImage(index);

//   // ===== SUBSCRIPTION CHECK (TENANT) =====
//   useEffect(() => {
//     const checkSubscription = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
//         const userSubscriptions = response.data;
//         const hasTenantSubscription = Array.isArray(userSubscriptions) &&
//           userSubscriptions.some(sub => sub.user_type === "Tenant");
//         setIsSubscribed(hasTenantSubscription);
//       } catch (error) {
//         console.error('Error checking subscription:', error);
//         setIsSubscribed(false);
//       }
//     };
//     if (userId) checkSubscription();
//     else setIsSubscribed(false);
//   }, [userId]);

//   // ===== WISHLIST CHECK =====
//   useEffect(() => {
//     const checkWishlist = async () => {
//       if (!userId) return;
//       try {
//         const response = await axios.get(`${BASE_URL}/get-user-cart/${userId}/`);
//         const items = Array.isArray(response.data) ? response.data : [];
//         const match = items.find(item => String(item.property_id) === String(propertyId));
//         if (match) {
//           setIsWishlisted(true);
//           setCartItemId(match.cart_id || match.id);
//         } else {
//           setIsWishlisted(false);
//           setCartItemId(null);
//         }
//       } catch (err) {
//         console.error('Wishlist check failed:', err);
//       }
//     };
//     if (userId) checkWishlist();
//   }, [userId, propertyId]);

//   // ===== WISHLIST TOGGLE =====
//     const handleWishlistToggle = async () => {
//     if (isGuest) {
//       setShowGuestModal(true);
//       return;
//     }
//     if (!userId) {
//       setShowGuestModal(true);
//       return;
//     }

//     setWishlistLoading(true);
//     try {
//       if (isWishlisted) {
//         // Remove
//         if (cartItemId) {
//           await axios.delete(`${BASE_URL}/user-cart/${cartItemId}/`);
//         }
//         setIsWishlisted(false);
//         setCartItemId(null);
//         setIsWishlistRemoved(true); // ✅ Set to true
//         setAlertMessage('Property removed from your wishlist.');
//         setShowSuccess(true);
//       } else {
//         // Add
//         const res = await axios.post(`${BASE_URL}/user-cart/`, {
//           user_id: userId,
//           property_id: propertyId,
//         });
//         setIsWishlisted(true);
//         setCartItemId(res.data?.cart_id || res.data?.id || null);
//         setIsWishlistRemoved(false); // ✅ Set to false
//         setAlertMessage('Property added to your wishlist.');
//         setShowSuccess(true);
//       }
//     } catch (err) {
//       console.error('Wishlist toggle failed:', err);
//       setAlertMessage('Failed to update wishlist');
//       setShowFailure(true);
//     } finally {
//       setWishlistLoading(false);
//     }
//   };

//   // ===== SHARE =====
//   const handleShare = async () => {
//     const url = `${window.location.origin}/rent-description/${propertyId}`;
//     try {
//       if (navigator.share) {
//         await navigator.share({
//           title: property?.property_name || 'Property',
//           text: 'Check out this property',
//           url,
//         });
//       } else {
//         await navigator.clipboard.writeText(url);
//         setAlertMessage('Property link copied to clipboard!');
//         setShowSuccess(true);
//       }
//     } catch (err) {
//       if (err.name === 'AbortError') return;
//       try {
//         await navigator.clipboard.writeText(url);
//         setAlertMessage('Property link copied to clipboard!');
//         setShowSuccess(true);
//       } catch {
//         setAlertMessage('Failed to share property');
//         setShowFailure(true);
//       }
//     }
//   };

//   // ===== USER ACTIVITIES =====
//   useEffect(() => {
//     const fetchUserActivities = async () => {
//       if (!userId) return;
//       try {
//         const response = await fetch(`${BASE_URL}/activities/`);
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         const allActivities = await response.json();
//         const filteredActivities = allActivities.filter(activity =>
//           activity && activity.user_id !== undefined && String(activity.user_id) === String(userId)
//         );
//         setUserActivities(filteredActivities);
//       } catch (error) {
//         console.error('Error fetching activities:', error);
//         setUserActivities([]);
//       }
//     };
//     fetchUserActivities();
//   }, [userId]);

//   const checkPropertyLimit = (currentPropertyId) => {
//     if (!isSubscribed) {
//       setFeatureRequested("Property Access");
//       setShowSubscribeModal(true);
//       return false;
//     }
//     if (userPlan?.no_of_properties_unlimited) return true;
//     const uniqueProperties = new Set(userActivities.map(a => a.property_id));
//     const isExistingProperty = uniqueProperties.has(currentPropertyId);
//     const propertyLimit = userPlan?.no_of_properties || 10;
//     if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   };

//   // ===== FIELD MAP (RENT) =====
//   const fieldMap = {
//     'Commercial land/plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
//     'Plot/land': ['Site Area', 'Facing', 'Price', 'Road Width'],
//     'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms', 'Lift', 'Road Width'],
//     'Duplex house': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms', 'Lift', 'Road Width'],
//     'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count', 'Lift', 'Road Width'],
//     'Pg-offices': ['Property Name', 'Site Area', 'Facing', 'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
//     'Flat': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
//     'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
//     'Commercial building': ['Property Name', 'Site Area', 'Facing', 'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
//     'Apartment': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
//     'JV/JD': ['Site Area', 'Facing', 'Price', 'Road Width'],
//   };

//   const images = property?.property_images && property.property_images.length > 0
//     ? property.property_images.map(img => `${BASE_URL}${img.image}`)
//     : [buildingImage];

//   // ===== LOCATION HANDLER =====
//   const handleLocationClick = async () => {
//     if (!isSubscribed) {
//       setFeatureRequested("Location Access");
//       setShowSubscribeModal(true);
//       return;
//     }
//     if (!checkPropertyLimit(property.id)) return;

//     setLoadingLocation(true);

//     const logActivity = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/activities/`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             user_id: userId,
//             property_id: property.id,
//             activity_type: "Location",
//             property_by: property.owner,
//             activity_as: "Tenant"
//           })
//         });
//         if (!response.ok) throw new Error('Failed to log location activity');
//         const newActivity = await response.json();
//         setUserActivities(prev => [...prev, newActivity]);
//       } catch (err) {
//         console.error("Error logging location activity:", err);
//       }
//     };

//     const openLocation = () => {
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const userLat = position.coords.latitude;
//             const userLong = position.coords.longitude;
//             if (property?.lat && property?.long) {
//               window.open(`https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLong}&destination=${property.lat},${property.long}`, '_blank');
//             } else if (property?.loc || property?.location) {
//               window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc || property.location)}`, '_blank');
//             }
//             setLoadingLocation(false);
//           },
//           () => {
//             if (property?.lat && property?.long) {
//               window.open(`https://www.google.com/maps/?q=${property.lat},${property.long}`, '_blank');
//             }
//             setLoadingLocation(false);
//           }
//         );
//       } else {
//         setLoadingLocation(false);
//       }
//     };

//     await logActivity();
//     openLocation();
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
//         setCategories(categoriesRes.data);
//         if (propertyId) {
//           const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
//           setProperty(propertyRes.data);
//         }
//       } catch (err) {
//         console.error('Failed to fetch data:', err);
//       }
//     };
//     fetchData();
//   }, [propertyId]);

//   if (!property) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <Typography>Loading property...</Typography>
//       </Box>
//     );
//   }

//   const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
//   const categoryName = propertyCategory ? propertyCategory.category : property.type;

//   const fieldsToDisplay = fieldMap[categoryName] || [];
//   const excludedDisplayFields = ['Site Area', 'Facing', 'Price', 'Road Width', 'No.of Floors', 'Buildup Area'];

//   const propertyDetails = fieldsToDisplay.map((field) => {
//     switch (field) {
//       case 'Site Area': return { label: 'Site Area', value: `${property.site_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
//       case 'Facing': return { label: 'Facing', value: property.facing?.replace(/"/g, '') || 'NA', icon: <CompassCalibrationOutlinedIcon /> };
//       case 'Price': return { label: 'Price', value: property.price ? property.price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }) : 'NA', icon: <SecurityOutlinedIcon /> };
//       case 'Road Width': return { label: 'Road Width', value: `${property.roadwidth || 'NA'} ft`, icon: <CropSquareOutlinedIcon /> };
//       case 'No.of Floors': return { label: 'No. of Floors', value: `${property.no_of_flores || 'NA'}`, icon: <LayersOutlinedIcon /> };
//       case 'Buildup Area': return { label: 'Buildup Area', value: `${property.buildup_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
//       case 'Borewell': return { label: 'Bore Well', value: property.borewell === 'Yes' ? 'Available' : 'Not Available', icon: <OpacityIcon /> };
//       case 'No.of Cars Parking': return { label: 'Parking', value: `${property.parking || 'NA'}`, icon: <DirectionsCarIcon /> };
//       case '1bhk Count': return { label: '1 BHK', value: property._1bhk_count ? `${property._1bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case '2bhk Count': return { label: '2 BHK', value: property._2bhk_count ? `${property._2bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case '3bhk Count': return { label: '3 BHK', value: property._3bhk_count ? `${property._3bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case '4bhk Count': return { label: '4 BHK', value: property._4bhk_count ? `${property._4bhk_count} No's` : 'NA', icon: <BedIcon /> };
//       case 'Duplex Bedrooms': return { label: 'Duplex BHK', value: property.duplex_bedrooms || 'NA', icon: <BedIcon /> };
//       case 'Lift': return { label: 'Lift', value: property.lift === 'Yes' ? 'Available' : 'Not Available', icon: <ElevatorIcon /> };
//       case 'House Count': return { label: 'House Count', value: property.house_count ? `${property.house_count} No's` : 'NA', icon: <HomeWorkIcon /> };
//       default: return null;
//     }
//   }).filter(detail => detail !== null && !excludedDisplayFields.includes(detail.label));

//   const groupedPropertyDetails = [];
//   for (let i = 0; i < propertyDetails.length; i += 2) {
//     groupedPropertyDetails.push(propertyDetails.slice(i, i + 2));
//   }

//   // ===== HIGHLIGHTS DATA (RENT) =====
//   const highlightsData = [
//     { icon: <BedIcon />, value: `${property.duplex_bedrooms || property._1bhk_count || property._2bhk_count || property._3bhk_count || '3'} BHK`, label: '(Duplex)' },
//     { icon: <DirectionsCarIcon />, value: `${property.parking || '3'} Cars`, label: '(Covered + Open)' },
//     { icon: <HomeWorkIcon />, value: `${property.buildup_area || '2400'} Sq.ft`, label: '(Per Floor)' },
//     { icon: <AccountBalanceWalletIcon />, value: `₹ ${property.price ? property.price.toLocaleString('en-IN') : 'NA'}`, label: '(Monthly Rent)' },
//     { icon: <CheckCircleOutlineIcon />, value: 'Lift, Power Backup', label: 'Security, CCTV, GST' },
//     { icon: <GroupIcon />, value: '100%', label: '(Occupied)' },
//     { icon: <EventAvailableIcon />, value: 'Immediate', label: 'Available For' },
//   ];

//   const groupedHighlights = [];
//   for (let i = 0; i < highlightsData.length; i += 2) {
//     groupedHighlights.push(highlightsData.slice(i, i + 2));
//   }

//   const descriptionText = property.description?.trim() ? property.description : 'No description available.';

//   return (
//     <Box sx={{ width: '100vw', minHeight: '100vh', backgroundColor: '#F8F3EC', pb: 8 }}>

//       {/* ===== HEADER ===== */}
//       <Box sx={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10,
//         bgcolor: '#3E2A1E', color: 'white',
//         px: 2, py: 1.5, display: 'flex', alignItems: 'center',
//       }}>
//         <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1, p: 0.5 }}>
//           <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
//         </IconButton>
//         <Typography sx={{ flex: 1, fontSize: '1rem', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//           {categoryName?.replace(/"/g, '') || 'Property'}
//         </Typography>
//       </Box>

//       <Box sx={{ pt: '60px' }}>

//         {/* ===== MAIN IMAGE ===== */}
//         <Box sx={{ position: 'relative', width: '100%', height: 260, overflow: 'hidden', bgcolor: '#000' }}>
//           <Carousel
//             selectedItem={selectedImage}
//             onChange={(index) => setSelectedImage(index)}
//             showThumbs={false} showArrows={false} autoPlay infiniteLoop interval={3000}
//             showIndicators={false} showStatus={false} swipeable emulateTouch
//             stopOnHover transitionTime={600} useKeyboardArrows
//           >
//             {images.map((image, index) => (
//               <Box key={index} sx={{ width: '100%', height: 260, position: 'relative', overflow: 'hidden' }}>
//                 <Box component="img" src={image} aria-hidden="true" sx={{
//                   position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) scale(1.3)',
//                   width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(16px)', opacity: 0.7, zIndex: 0,
//                 }} />
//                 <Box component="img" src={image} alt="Property" loading="lazy" sx={{
//                   position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                   width: '100%', height: '100%', objectFit: 'contain', zIndex: 1,
//                 }} />
//                 <Box sx={{
//                   position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
//                   pointerEvents: 'none', zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 }}>
//                   <Typography sx={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', color: 'rgba(255, 255, 255, 0.54)', whiteSpace: 'nowrap' }}>
//                     PROPERTY PINCODER
//                   </Typography>
//                 </Box>
//               </Box>
//             ))}
//           </Carousel>

//           <Box sx={{
//             position: 'absolute', bottom: 10, right: 10, zIndex: 5,
//             bgcolor: 'rgba(0,0,0,0.6)', color: 'white',
//             px: 1.2, py: 0.3, borderRadius: '20px',
//             display: 'flex', alignItems: 'center', gap: 0.5,
//           }}>
//             <Box component="span" sx={{ fontSize: '0.7rem' }}>📷</Box>
//             <Typography sx={{ fontSize: '0.7rem', fontWeight: 600 }}>{selectedImage + 1}/{images.length}</Typography>
//           </Box>
//         </Box>

//         {/* ===== THUMBNAILS ===== */}
//         <Box sx={{
//           display: 'flex', overflowX: 'auto', gap: 1, px: 1.5, py: 1.5,
//           '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none', msOverflowStyle: 'none',
//         }}>
//           {images.map((image, index) => (
//             <Box key={index} onClick={() => handleImageClick(index)} sx={{
//               width: 90, minWidth: 90, height: 60, borderRadius: '8px', overflow: 'hidden',
//               cursor: 'pointer', flexShrink: 0,
//               border: selectedImage === index ? '2px solid #8A6A3D' : '2px solid transparent',
//               transition: 'all 0.2s ease',
//             }}>
//               <Box component="img" src={image} alt={`Thumb ${index + 1}`} loading="lazy"
//                 sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//             </Box>
//           ))}
//           {images.length > 3 && (
//             <Box sx={{
//               width: 90, minWidth: 90, height: 60, borderRadius: '8px',
//               bgcolor: '#3E2A1E', color: 'white',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               fontSize: '0.8rem', fontWeight: 600, flexShrink: 0,
//             }}>
//               +{images.length - 3}
//             </Box>
//           )}
//         </Box>

//         {/* ===== TITLE & PRICE ===== */}
//         <Box sx={{ px: 1, mb: 1 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
//             <Typography sx={{ flex: 1, fontSize: '1.05rem', fontWeight: 700, color: '#222', lineHeight: 1.3 }}>
//               {categoryName?.replace(/"/g, '')} {property.property_name ? `- ${property.property_name}` : ''}
//             </Typography>
//             <Box sx={{
//               bgcolor: '#F5DEB3', color: '#5C3D1E',
//               px: 1.2, py: 0.5, borderRadius: '8px',
//               fontSize: '0.9rem', fontWeight: 700, whiteSpace: 'nowrap',
//               border: '1px solid #E8C99A',
//             }}>
//               ₹ {property.price ? property.price.toLocaleString('en-IN') : 'NA'}
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== PROPERTY ID + WISHLIST + SHARE ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1,
//               mb: 0.8,
//               flexWrap: 'nowrap',
//             }}
//           >
//             {/* Property ID Box */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 0.5,
//                 bgcolor: '#F5DEB3',
//                 border: '1px solid #E8C99A',
//                 borderRadius: '8px',
//                 px: 1,
//                 py: 0.5,
//                 flex: 1,
//                 minWidth: 0,
//               }}
//             >
//               <Typography sx={{ fontSize: '0.75rem', color: '#5C3D1E', fontWeight: 600, whiteSpace: 'nowrap' }}>
//                 Property Id :
//               </Typography>
//               <Typography sx={{
//                 fontSize: '0.75rem', color: '#5C3D1E', fontWeight: 700,
//                 whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
//               }}>
//                 {property.id || propertyId}
//               </Typography>
//             </Box>

//             {/* Wishlist Button */}
//             <Tooltip title={isWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist'}>
//               <Box
//                 onClick={handleWishlistToggle}
//                 sx={{
//                   display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5,
//                   bgcolor: '#FFF', border: '1px solid #E8C99A',
//                   borderRadius: '8px', px: 1.2, py: 0.5,
//                   cursor: wishlistLoading ? 'wait' : 'pointer',
//                   flexShrink: 0, transition: 'all 0.2s',
//                   '&:hover': { bgcolor: '#FDF3E7' },
//                 }}
//               >
//                 {wishlistLoading ? (
//                   <CircularProgress size={16} sx={{ color: '#E53935' }} />
//                 ) : isWishlisted ? (
//                   <Favorite sx={{ fontSize: 18, color: '#E53935' }} />
//                 ) : (
//                   <FavoriteBorder sx={{ fontSize: 18, color: '#5C3D1E' }} />
//                 )}
//                 <Typography sx={{
//                   fontSize: '0.72rem', fontWeight: 700,
//                   color: isWishlisted ? '#E53935' : '#5C3D1E',
//                   whiteSpace: 'nowrap',
//                 }}>
//                   {isWishlisted ? 'Wishlisted' : 'Wishlist'}
//                 </Typography>
//               </Box>
//             </Tooltip>

//             {/* Share Button */}
//             <Tooltip title="Share this property">
//               <Box
//                 onClick={handleShare}
//                 sx={{
//                   display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5,
//                   bgcolor: '#FFF', border: '1px solid #E8C99A',
//                   borderRadius: '8px', px: 1.2, py: 0.5,
//                   cursor: 'pointer', flexShrink: 0, transition: 'all 0.2s',
//                   '&:hover': { bgcolor: '#FDF3E7' },
//                 }}
//               >
//                 <ShareIcon sx={{ fontSize: 18, color: '#5C3D1E' }} />
//                 <Typography sx={{
//                   fontSize: '0.72rem', fontWeight: 700, color: '#5C3D1E', whiteSpace: 'nowrap',
//                 }}>
//                   Share
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>

//           {/* Location text */}
//           <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}>
//             <Typography sx={{ fontSize: '0.8rem', color: '#555', lineHeight: 1.4 }}>
//               {property.location || 'Not Specified'}
//             </Typography>
//           </Box>
//         </Box>

//         {/* ===== SITE AREA / ROAD WIDTH / FACING ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Box sx={{
//             display: 'flex', justifyContent: 'space-between',
//             bgcolor: '#FBF5ED', border: '1px solid #E8DCC8',
//             borderRadius: '10px', p: 1.5,
//           }}>
//             <Box sx={{ textAlign: 'center', flex: 1 }}>
//               <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
//                 <HomeWorkIcon />
//               </Box>
//               <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
//                 {property.site_area || property.max_acres ? (() => {
//                   const value = property.site_area || property.max_acres;
//                   const unitRaw = property.units || '';
//                   const unit = unitRaw.toLowerCase();
//                   if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) return `${value} ${unitRaw}`;
//                   const hasSq = unit.includes('sq');
//                   return `${value} ${hasSq ? unitRaw : `Sq ${unitRaw || 'ft'}`}`;
//                 })() : 'NA'}
//               </Typography>
//               <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Site Area</Typography>
//             </Box>
//             <Box sx={{ width: '1px', bgcolor: '#E8DCC8' }} />
//             <Box sx={{ textAlign: 'center', flex: 1 }}>
//               <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
//                 <StraightenIcon />
//               </Box>
//               <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
//                 {property.roadwidth || 'NA'} ft
//               </Typography>
//               <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Road Width</Typography>
//             </Box>
//             <Box sx={{ width: '1px', bgcolor: '#E8DCC8' }} />
//             <Box sx={{ textAlign: 'center', flex: 1 }}>
//               <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
//                 <CompassCalibrationOutlinedIcon />
//               </Box>
//               <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
//                 {property.facing?.replace(/"/g, '') || 'NA'}
//               </Typography>
//               <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Facing</Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== PROPERTY HIGHLIGHTS ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Box sx={{
//             bgcolor: '#FFFFFF', border: '1px solid #E8DCC8',
//             borderRadius: '12px', p: 1.5,
//           }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <HomeIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                 <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
//                   Property Highlights
//                 </Typography>
//               </Box>
//               <Box sx={{
//                 bgcolor: '#F5DEB3', color: '#5C3D1E',
//                 px: 1, py: 0.2, borderRadius: '4px',
//                 fontSize: '0.7rem', fontWeight: 600,
//                 border: '1px solid #E8C99A',
//               }}>
//                 For Rent
//               </Box>
//             </Box>

//             <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 0.5 }}>
//               {groupedHighlights.map((row, rowIndex) => (
//                 <Box
//                   key={rowIndex}
//                   sx={{
//                     display: 'flex', width: '100%',
//                     borderBottom: rowIndex !== groupedHighlights.length - 1 ? '1px solid #F0E6D6' : 'none',
//                   }}
//                 >
//                   {row.map((item, colIndex) => (
//                     <Box
//                       key={colIndex}
//                       sx={{
//                         flex: '0 0 50%',
//                         display: 'flex', alignItems: 'center', gap: 1,
//                         py: 1.2, px: 0.5, boxSizing: 'border-box',
//                         borderRight: colIndex === 0 ? '1px solid #F0E6D6' : 'none',
//                         minWidth: 0,
//                       }}
//                     >
//                       <Box sx={{
//                         color: '#8A6A3D', flexShrink: 0,
//                         display: 'flex', alignItems: 'center',
//                         '& svg': { fontSize: 20 },
//                       }}>
//                         {item.icon}
//                       </Box>
//                       <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
//                         <Typography sx={{
//                           fontSize: '0.85rem', fontWeight: 600, color: '#222',
//                           lineHeight: 1.2, whiteSpace: 'normal', wordBreak: 'break-word',
//                         }}>
//                           {item.value}
//                         </Typography>
//                         <Typography sx={{
//                           fontSize: '0.7rem', color: '#777',
//                           lineHeight: 1.2, whiteSpace: 'normal', wordBreak: 'break-word',
//                         }}>
//                           {item.label}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                   {row.length === 1 && <Box sx={{ flex: '0 0 50%' }} />}
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== PROPERTY DETAILS (Collapsible) ===== */}
//         <Box sx={{ px: 1, mb: 1.5 }}>
//           <Accordion expanded={detailsExpanded} onChange={() => setDetailsExpanded(!detailsExpanded)}
//             sx={{
//               borderRadius: '12px !important', border: '1px solid #E8DCC8',
//               boxShadow: 'none', '&:before': { display: 'none' },
//               '&.Mui-expanded': { margin: 0 },
//             }}>
//             <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#8A6A3D' }} />}
//               sx={{ px: 1.5, minHeight: 48, '&.Mui-expanded': { minHeight: 48 } }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <ApartmentIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                 <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
//                   Property Details
//                 </Typography>
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
//               <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 1.5 }}>
//                 {groupedPropertyDetails.map((row, rowIndex) => (
//                   <Box key={rowIndex} sx={{ display: 'flex', width: '100%', borderBottom: rowIndex !== groupedPropertyDetails.length - 1 ? '1px solid #F0E6D6' : 'none' }}>
//                     {row.map((item, colIndex) => (
//                       <Box key={colIndex} sx={{
//                         flex: '0 0 50%', display: 'flex', alignItems: 'center', gap: 1,
//                         py: 1.2, px: 0.5, boxSizing: 'border-box',
//                         borderRight: colIndex === 0 ? '1px solid #F0E6D6' : 'none',
//                         minWidth: 0,
//                       }}>
//                         <Box sx={{ color: '#8A6A3D', flexShrink: 0, display: 'flex', alignItems: 'center', '& svg': { fontSize: 20 } }}>
//                           {item.icon}
//                         </Box>
//                         <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
//                           <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222', lineHeight: 1.2 }}>
//                             {item.value}
//                           </Typography>
//                           <Typography sx={{ fontSize: '0.7rem', color: '#777', lineHeight: 1.2 }}>
//                             {item.label}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     ))}
//                     {row.length === 1 && <Box sx={{ flex: '0 0 50%' }} />}
//                   </Box>
//                 ))}

//                 {/* Length * Width */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <CropSquareOutlinedIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                     <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Length * Width</Typography>
//                   </Box>
//                   <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
//                     {property.length && property.width ? (() => {
//                       const unitRaw = property.units || "";
//                       const unit = unitRaw.toLowerCase();
//                       if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) return `${property.length} * ${property.width} ${unitRaw}`;
//                       return `${property.length} * ${property.width} Sq ${unitRaw || 'ft'}`;
//                     })() : "NA"}
//                   </Typography>
//                 </Box>

//                 {/* Average Price */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <SecurityOutlinedIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                     <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Average Price</Typography>
//                   </Box>
//                   <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
//                     {property.price ? (() => {
//                       let area = 0;
//                       if (property.buildup_area) {
//                         area = parseFloat(property.buildup_area);
//                         const floors = parseInt(property.no_of_flores || property.floor || 0);
//                         if (floors > 0) area = area * floors;
//                       } else if (property.site_area || property.max_acres) {
//                         area = parseFloat(property.site_area || property.max_acres);
//                       }
//                       if (!area || area <= 0) return "NA";
//                       const avgPrice = parseFloat(property.price) / area;
//                       const unitRaw = property.units || "";
//                       const unit = unitRaw.toLowerCase();
//                       if (["acre", "acres", "gunta", "guntas"].includes(unit)) return `₹${avgPrice.toFixed(2)} / ${unitRaw}`;
//                       const hasSq = unit.includes("sq");
//                       return `₹${avgPrice.toFixed(2)} / ${hasSq ? unitRaw : `Sq ${unitRaw || "ft"}`}`;
//                     })() : "NA"}
//                   </Typography>
//                 </Box>

//                 {/* Posted On */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <TodayIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                     <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Posted On</Typography>
//                   </Box>
//                   <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
//                     {formatIndianDate(property.created_at)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </AccordionDetails>
//           </Accordion>
//         </Box>

//         {/* ADDED COMPONENT */}
//         <AddPropertyCards />

//         {/* ===== DESCRIPTION ===== */}
//         <Box sx={{ px: 0.5, mb: 0.5 }}>
//           <Accordion
//             expanded={descriptionExpanded}
//             onChange={() => { /* locked open */ }}
//             sx={{
//               borderRadius: '12px !important',
//               border: '1px solid #E8DCC8',
//               boxShadow: 'none',
//               '&:before': { display: 'none' },
//               '&.Mui-expanded': { margin: 0 },
//             }}
//           >
//             <AccordionSummary
//               expandIcon={null}
//               sx={{ px: 0.5, minHeight: 30, '&.Mui-expanded': { minHeight: 48 }, cursor: 'default' }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <DescriptionIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
//                 <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
//                   Description
//                 </Typography>
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails sx={{ px: 1, pt: 0 }}>
//               <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 1 }}>
//                 <Typography
//                   sx={{
//                     fontSize: '0.8rem',
//                     color: '#555',
//                     lineHeight: 1.6,
//                     whiteSpace: 'pre-wrap',
//                     wordBreak: 'break-word',
//                     display: '-webkit-box',
//                     WebkitBoxOrient: 'vertical',
//                     WebkitLineClamp: descriptionClampExpanded ? 'unset' : 5,
//                     overflow: 'hidden',
//                   }}
//                 >
//                   {descriptionText}
//                 </Typography>

//                 <Box
//                   onClick={() => setDescriptionClampExpanded(!descriptionClampExpanded)}
//                   sx={{
//                     mt: 1,
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     gap: 0.5,
//                     cursor: 'pointer',
//                     color: '#8A6A3D',
//                     fontWeight: 700,
//                     fontSize: '0.8rem',
//                     userSelect: 'none',
//                     '&:hover': { textDecoration: 'underline' },
//                   }}
//                 >
//                   <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#8A6A3D' }}>
//                     {descriptionClampExpanded ? 'Show Less' : 'Show More'}
//                   </Typography>
//                   <ExpandMoreIcon
//                     sx={{
//                       fontSize: 18,
//                       color: '#8A6A3D',
//                       transition: 'transform 0.2s',
//                       transform: descriptionClampExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
//                     }}
//                   />
//                 </Box>
//               </Box>
//             </AccordionDetails>
//           </Accordion>
//         </Box>

//         {/* ===== SELLER CARD (Posted time + name + role + Chat now) ===== */}
//         <Box sx={{ px: 0.5, mb: 1 }}>
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               gap: 1,
//               bgcolor: '#FFFFFF',
//               border: '1px solid #EEE',
//               borderRadius: '12px',
//               px: 1.5,
//               py: 1.2,
//               boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
//             }}
//           >
//             {/* Left: avatar + text */}
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, minWidth: 0 }}>
//               <Box
//                 sx={{
//                   width: 44,
//                   height: 44,
//                   borderRadius: '50%',
//                   bgcolor: '#a87c51',
//                   color: '#fff',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   flexShrink: 0,
//                   fontWeight: 700,
//                   fontSize: '1rem',
//                   overflow: 'hidden',
//                 }}
//               >
//                 {property?.user_first_name ? (
//                   property.user_first_name.charAt(0).toUpperCase()
//                 ) : (
//                   <PersonIcon sx={{ fontSize: 24 }} />
//                 )}
//               </Box>

//               <Box sx={{ minWidth: 0 }}>
//                 <Typography
//                   sx={{
//                     fontSize: '0.72rem',
//                     color: '#888',
//                     lineHeight: 1.2,
//                     fontWeight: 500,
//                   }}
//                 >
//                   Posted {formatTimeAgo(property?.created_at)} by
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: '0.95rem',
//                     fontWeight: 700,
//                     color: '#222',
//                     lineHeight: 1.25,
//                     whiteSpace: 'nowrap',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     maxWidth: 180,
//                   }}
//                 >
//                   {getSellerName(property)}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: '0.75rem',
//                     color: '#666',
//                     lineHeight: 1.2,
//                   }}
//                 >
//                   {property?.posted_by || 'Owner'}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Right: Chat now + caption */}
//             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', flexShrink: 0 }}>
//               <Box
//                 onClick={handleChatNowClick}
//                 sx={{
//                   bgcolor: '#a87c51',
//                   color: '#fff',
//                   px: 2,
//                   py: 0.9,
//                   borderRadius: '10px',
//                   fontWeight: 700,
//                   fontSize: '0.85rem',
//                   cursor: 'pointer',
//                   transition: 'background 0.2s',
//                   '&:hover': { bgcolor: '#a87c51' },
//                 }}
//               >
//                 Chat now
//               </Box>
//               <Typography sx={{ fontSize: '0.65rem', color: '#888', mt: 0.4 }}>
//                 Free, fast &amp; secure
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* ===== ACTION BUTTONS: View Number + View on Map ===== */}
//         <Box
//           sx={{
//             px: 0.5,
//             mb: 1,
//             display: 'flex',
//             justifyContent: 'space-between',
//             gap: 1,
//           }}
//         >
//           {/* View Number */}
//           <Box
//             onClick={() => handleCopyMobile(property.mobile_no)}
//             sx={{
//               flex: 1,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: 1,
//               bgcolor: '#FDF8F2',
//               border: '1px solid #a87c51',
//               borderRadius: '8px',
//               px: 1,
//               py: 1.2,
//               cursor: 'pointer',
//               transition: 'all 0.2s',
//               '&:hover': { bgcolor: '#F5ECE0' },
//             }}
//           >
//             <CallIcon sx={{ color: '#6B3620', fontSize: 22 }} />
//             <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#6B3620' }}>
//               View Number
//             </Typography>
//           </Box>

//           {/* View on Map */}
//           <Box
//             onClick={handleLocationClick}
//             sx={{
//               flex: 1,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: 1,
//               bgcolor: '#FDF8F2',
//               border: '1px solid #a87c51',
//               borderRadius: '8px',
//               px: 1,
//               py: 1.2,
//               cursor: 'pointer',
//               transition: 'all 0.2s',
//               '&:hover': { bgcolor: '#F5ECE0' },
//             }}
//           >
//             {loadingLocation ? (
//               <CircularProgress size={20} sx={{ color: '#6B3620' }} />
//             ) : (
//               <LocationOnIcon sx={{ color: '#6B3620', fontSize: 22 }} />
//             )}
//             <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#6B3620' }}>
//               View on Map
//             </Typography>
//           </Box>
//         </Box>

//       </Box>

//       {/* ===== MODALS & ALERTS ===== */}
//       {showSubscribeModal && (
//         <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center', borderRadius: 3 }}>
//             <Typography variant="h6" gutterBottom fontWeight="bold">Subscription Required</Typography>
//             <Typography variant="body2" sx={{ mb: 2 }}>Please subscribe to use the {featureRequested} feature.</Typography>
//             <Button variant="contained" onClick={() => setShowSubscribeModal(false)} sx={{ bgcolor: '#8A6A3D', '&:hover': { bgcolor: '#6d5230' } }}>OK</Button>
//           </Paper>
//         </Box>
//       )}

//       {showLimitModal && (
//         <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center', borderRadius: 3 }}>
//             <Typography variant="h6" gutterBottom fontWeight="bold">Limit Exceeded</Typography>
//             <Typography variant="body2" sx={{ mb: 2 }}>
//               {userPlan?.no_of_properties_unlimited ? "You have unlimited access to properties." : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. Please upgrade your subscription plan for more.`}
//             </Typography>
//             <Button variant="contained" onClick={() => setShowLimitModal(false)} sx={{ bgcolor: '#8A6A3D', '&:hover': { bgcolor: '#6d5230' } }}>OK</Button>
//           </Paper>
//         </Box>
//       )}

//            {showSuccess && (
//         <WishlistSuccessAlert
//           message={alertMessage}
//           isRemoved={isWishlistRemoved} // ✅ Pass the state to change icon color and button
//           onClose={() => { setShowSuccess(false); setAlertMessage(""); }}
//         />
//       )}
//       {showFailure && <CopyFailureAlert message={alertMessage} onClose={() => { setShowFailure(false); setAlertMessage(""); }} />}

//       <GuestLoginModal
//         open={showGuestModal}
//         onClose={() => setShowGuestModal(false)}
//       />

//       <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
//         <CustomBottomNav />
//       </Paper>
//     </Box>
//   );
// };

// export default Rent_description;


import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Typography, IconButton, Paper, Button, CircularProgress,
  Accordion, AccordionSummary, AccordionDetails, Tooltip, Card, CardContent
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import BedIcon from '@mui/icons-material/Bed';
import ElevatorIcon from '@mui/icons-material/Elevator';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import OpacityIcon from '@mui/icons-material/Opacity';
import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import buildingImage from './../../../Images/house.jpeg';
import CustomBottomNav from './BottomNavbar/BottomNavbar';
import { BASE_URL } from './../../Api/ApiUrls';
import { AuthContext } from './../../AuthContext/AuthContext';
import CallIcon from '@mui/icons-material/Call';
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
import DescriptionIcon from '@mui/icons-material/Description';
import AddPropertyCards from '../AddsProducts/RentDescriptionCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HomeIcon from '@mui/icons-material/Home';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import GroupIcon from '@mui/icons-material/Group';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import StraightenIcon from '@mui/icons-material/Straighten';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ApartmentIcon from '@mui/icons-material/Apartment';
import TodayIcon from '@mui/icons-material/Today';
import PersonIcon from '@mui/icons-material/Person';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import GuestLoginModal from '../../GuestLoginModal';
import WishlistSuccessAlert from '../Alertpage/CopyAlert/WishlistSuccessAlert';

// --- NEW CUSTOM MODALS ---
import ChatModal from '../Buy Module/ChatModal';
import PhoneModal from '../Buy Module/PhoneModal'; 
import MapModal from '../Buy Module/MapModal';     
import ShareModal from '../Buy Module/ShareModal'; // Added for the share icon
import {
  CheckCircle, Security, Bolt, Groups, Pool, FitnessCenter, SportsEsports,
  DirectionsRun, ChildCare, Park, SelfImprovement, MeetingRoom, Theaters, Work,
  ElectricCar, LocalParking, Water, Videocam, ChildFriendly, Spa, HotTub,
  SportsTennis, SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
  LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub, FormatPaint,
  Train, Flight, DirectionsBus, School, LocalHospital, ShoppingCart,
  ApartmentOutlined, Description, Gavel, AccountBalance,
} from '@mui/icons-material';

const COLORS = {
  primary: '#8B4A2B', primaryDark: '#6B3620', cardBg: '#FFFFFF',
  blue: '#1565C0', textSecondary: '#8A7A6D', textDark: '#2B2118', border: '#F0E6DA',
};

const AMENITY_CATEGORIES = [
  "Recreation", "Fitness & Wellness", "Sports", "Security",
  "Utilities", "Building Facilities", "Family & Convenience",
];

const AMENITY_CATEGORY_MAP = {
  "Swimming Pool": "Recreation", "Kids Pool": "Recreation", "Club House": "Recreation",
  "Indoor Games": "Recreation", "Mini Theatre": "Recreation", "Party Hall": "Recreation",
  "Library": "Recreation", "Cafe": "Recreation", "Guest Rooms": "Recreation",
  "Gym": "Fitness & Wellness", "Yoga Room": "Fitness & Wellness", "Jogging Track": "Fitness & Wellness",
  "Cycling Track": "Fitness & Wellness", "Spa": "Fitness & Wellness", "Sauna": "Fitness & Wellness",
  "Steam Room": "Fitness & Wellness", "Meditation Area": "Fitness & Wellness", "Fitness Centre": "Fitness & Wellness",
  "Tennis Court": "Sports", "Basketball Court": "Sports", "Badminton Court": "Sports",
  "Cricket Net": "Sports", "Football Field": "Sports", "Table Tennis": "Sports",
  "Volleyball Court": "Sports", "Skating Area": "Sports", "Kids Play Area": "Sports",
  "24x7 Security": "Security", "CCTV Surveillance": "Security", "Video Door Phone": "Security",
  "Intercom": "Security", "Gated Entry": "Security", "Visitor Mgmt": "Security",
  "Fire Safety": "Security", "Access Control": "Security", "Emergency Exit": "Security",
  "Power Backup": "Utilities", "Water Supply": "Utilities", "Rainwater Harvesting": "Utilities",
  "Sewage Treatment": "Utilities", "Waste Mgmt": "Utilities", "Solar Power": "Utilities",
  "EV Charging": "Utilities", "Gas Pipeline": "Utilities", "STP / WTP": "Utilities",
  "High Speed Lift": "Building Facilities", "Lobby": "Building Facilities", "Reception": "Building Facilities",
  "Waiting Area": "Building Facilities", "Basement Parking": "Building Facilities",
  "Maintenance": "Building Facilities", "Housekeeping": "Building Facilities",
  "Service Lift": "Building Facilities", "Common Terrace": "Building Facilities",
  "Creche/Day Care": "Family & Convenience", "Senior Citizen Area": "Family & Convenience",
  "Convenience Store": "Family & Convenience", "Pharmacy": "Family & Convenience",
  "ATM": "Family & Convenience", "Salon": "Family & Convenience", "Laundry": "Family & Convenience",
  "Medical Centre": "Family & Convenience",
};

const CATEGORY_KEYWORDS = [
  { cat: "Recreation", keys: ["pool", "club house", "indoor games", "mini theatre", "party hall", "library", "cafe", "guest room"] },
  { cat: "Fitness & Wellness", keys: ["gym", "yoga", "jogging", "cycling", "spa", "sauna", "steam", "meditation", "fitness"] },
  { cat: "Sports", keys: ["tennis", "basketball", "badminton", "cricket", "football", "table tennis", "volleyball", "skating", "kids play", "play area"] },
  { cat: "Security", keys: ["security", "cctv", "video door", "intercom", "gated entry", "visitor", "fire safety", "access control", "emergency exit"] },
  { cat: "Utilities", keys: ["power backup", "water supply", "rainwater", "rain water", "sewage", "waste", "solar", "ev charging", "gas pipeline", "stp", "wtp"] },
  { cat: "Building Facilities", keys: ["lift", "lobby", "reception", "waiting", "basement parking", "maintenance", "housekeeping", "terrace"] },
  { cat: "Family & Convenience", keys: ["creche", "day care", "senior citizen", "convenience", "store", "pharmacy", "atm", "salon", "laundry", "medical"] },
];

const getAmenityCategory = (name = "") => {
  if (AMENITY_CATEGORY_MAP[name]) return AMENITY_CATEGORY_MAP[name];
  const lower = String(name).toLowerCase();
  for (const { cat, keys } of CATEGORY_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return cat;
  }
  return "Other";
};

const groupAmenitiesByCategory = (amenities = []) => {
  const groups = {};
  amenities.forEach((name) => {
    const cat = getAmenityCategory(name);
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(name);
  });
  return groups;
};

const ICON_KEYWORDS = [
  { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
  { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
  { keys: ['club', 'community'], icon: Groups },
  { keys: ['swim', 'pool'], icon: Pool },
  { keys: ['gym', 'fitness'], icon: FitnessCenter },
  { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
  { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
  { keys: ['child', 'kid', 'play'], icon: ChildCare },
  { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
  { keys: ['yoga', 'meditation'], icon: SelfImprovement },
  { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
  { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
  { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
  { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
  { keys: ['visitor', 'parking'], icon: LocalParking },
  { keys: ['rain', 'water', 'harvest'], icon: Water },
  { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
  { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
  { keys: ['spa'], icon: Spa },
  { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
  { keys: ['badminton', 'tennis'], icon: SportsTennis },
  { keys: ['basketball'], icon: SportsBasketball },
  { keys: ['cricket', 'net'], icon: SportsCricket },
  { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
  { keys: ['cycling', 'bike'], icon: DirectionsBike },
  { keys: ['library', 'reading'], icon: LocalLibrary },
  { keys: ['cafe', 'coffee'], icon: LocalCafe },
  { keys: ['event', 'auditorium'], icon: Event },
  { keys: ['hotel', 'guest', 'room'], icon: Hotel },
  { keys: ['flooring', 'floor', 'texture'], icon: Texture },
  { keys: ['kitchen', 'modular'], icon: Kitchen },
  { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
  { keys: ['painting', 'paint'], icon: FormatPaint },
  { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
  { keys: ['door', 'window'], icon: MeetingRoom },
  { keys: ['metro', 'train', 'railway'], icon: Train },
  { keys: ['airport', 'flight'], icon: Flight },
  { keys: ['bus', 'transit'], icon: DirectionsBus },
  { keys: ['school', 'college', 'education'], icon: School },
  { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
  { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
  { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
  { keys: ['brochure', 'document', 'pdf'], icon: Description },
  { keys: ['legal', 'rera', 'approval'], icon: Gavel },
  { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
];

const resolveIcon = (label = '') => {
  const lower = String(label).toLowerCase();
  for (const { keys, icon } of ICON_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return icon;
  }
  return CheckCircle;
};

const IconGrid = ({ items, emptyText }) => {
  if (!items || items.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 1 }}>
        {emptyText || 'Not available'}
      </Typography>
    );
  }
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
      {items.map((raw) => {
        const name = typeof raw === 'string' ? raw : raw.name;
        const IconComp = resolveIcon(name);
        return (
          <Box
            key={name}
            sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
              borderRadius: '10px', border: `1px solid ${COLORS.border}`,
              backgroundColor: COLORS.cardBg, minHeight: '60px', justifyContent: 'center', overflow: 'hidden',
            }}
          >
            <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
            <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
              {name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
    {onViewAll && (
      <Typography variant="body2" onClick={onViewAll} sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}>
        {expanded ? 'Show Less' : 'View All'}
      </Typography>
    )}
  </Box>
);

const EmptyText = ({ children }) => (
  <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
    {children}
  </Typography>
);

const Rent_description = () => { 
  const navigate = useNavigate();
  const location = useLocation();
  const { propertyId: paramPropertyId } = useParams();
  const { userId, isGuest } = useContext(AuthContext);
    const [showAllHighlights, setShowAllHighlights] = useState(false);
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState('All');

  const { propertyId: statePropertyId } = location.state || {};
  const propertyId = statePropertyId || paramPropertyId;

  const [loadingLocation, setLoadingLocation] = useState(false);
  const [categories, setCategories] = useState([]);
  const [property, setProperty] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [featureRequested, setFeatureRequested] = useState('');
  const [userPlan, setUserPlan] = useState(null);
  const [userActivities, setUserActivities] = useState([]);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [detailsExpanded, setDetailsExpanded] = useState(true);

  // ===== Description state =====
  const [descriptionExpanded] = useState(true);
  const [descriptionClampExpanded, setDescriptionClampExpanded] = useState(false);

  // ===== Wishlist + Share state =====
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [wishlistLoading, setWishlistLoading] = useState(false);
  const [cartItemId, setCartItemId] = useState(null);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [isWishlistRemoved, setIsWishlistRemoved] = useState(false);

  // --- NEW MODAL STATES ---
  const [showChatModal, setShowChatModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  // ─────────────────────────────────────────────────────────────
  // Chat now click handler
  // ─────────────────────────────────────────────────────────────
  const handleChatNowClick = () => {
    setShowChatModal(true); 
  };

  const confirmOpenChat = () => {
    setShowChatModal(false);
    navigate('/chat', {
      state: { property: propertyId }
    });
  };

  // ---- VIEW NUMBER LOGIC ----
  const handleViewNumberClick = () => {
    if (!isSubscribed) {
      setFeatureRequested("Contact Details");
      setShowSubscribeModal(true);
      return;
    }
    if (!checkPropertyLimit(property.id)) return;
    setShowPhoneModal(true); 
  };

  // ---- LOCATION LOGIC ----
  const handleOpenMapLocation = () => {
    if (!isSubscribed) {
      setFeatureRequested("Location Access");
      setShowSubscribeModal(true);
      return;
    }
    if (!checkPropertyLimit(property.id)) return;
    setShowMapModal(true); 
  };

  const executeOpenMap = () => {
    setShowMapModal(false);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLong = position.coords.longitude;
          if (property?.lat && property?.long) {
            window.open(`https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLong}&destination=${property.lat},${property.long}`, '_blank');
          } else if (property?.loc || property?.location) {
            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc || property.location)}`, '_blank');
          }
        },
        () => {
           if (property?.loc || property?.location) window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc || property.location)}`, '_blank');
        }
      );
    } else {
       if (property?.loc || property?.location) window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc || property.location)}`, '_blank');
    }
  };

  // ✅ Indian date format helper
  const formatIndianDate = (dateString) => {
    if (!dateString) return 'NA';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    } catch {
      return 'NA';
    }
  };

  // ===== "time ago" helper (seller card) =====
  const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    const now = new Date();
    const then = new Date(dateString);
    const diffMs = now - then;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins} min ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 30) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    if (diffMonths < 12) return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
    return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
  };

  const getSellerName = (p) => {
    const first = p?.user_first_name?.trim();
    const last = p?.user_last_name?.trim();
    if (first || last) return `${first || ''} ${last || ''}`.trim();
    return p?.posted_by || 'Owner';
  };

  const handleImageClick = (index) => setSelectedImage(index);

  // ===== SUBSCRIPTION CHECK (TENANT) =====
  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
        const userSubscriptions = response.data;
        const hasTenantSubscription = Array.isArray(userSubscriptions) &&
          userSubscriptions.some(sub => sub.user_type === "Tenant");
        setIsSubscribed(hasTenantSubscription);
      } catch (error) {
        console.error('Error checking subscription:', error);
        setIsSubscribed(false);
      }
    };
    if (userId) checkSubscription();
    else setIsSubscribed(false);
  }, [userId]);

  // ===== WISHLIST CHECK =====
  useEffect(() => {
    const checkWishlist = async () => {
      if (!userId) return;
      try {
        const response = await axios.get(`${BASE_URL}/get-user-cart/${userId}/`);
        const items = Array.isArray(response.data) ? response.data : [];
        const match = items.find(item => String(item.property_id) === String(propertyId));
        if (match) {
          setIsWishlisted(true);
          setCartItemId(match.cart_id || match.id);
        } else {
          setIsWishlisted(false);
          setCartItemId(null);
        }
      } catch (err) {
        console.error('Wishlist check failed:', err);
      }
    };
    if (userId) checkWishlist();
  }, [userId, propertyId]);

  // ===== WISHLIST TOGGLE =====
  const handleWishlistToggle = async () => {
    if (isGuest) {
      setShowGuestModal(true);
      return;
    }
    if (!userId) {
      setShowGuestModal(true);
      return;
    }

    setWishlistLoading(true);
    try {
      if (isWishlisted) {
        if (cartItemId) {
          await axios.delete(`${BASE_URL}/user-cart/${cartItemId}/`);
        }
        setIsWishlisted(false);
        setCartItemId(null);
        setIsWishlistRemoved(true); 
        setAlertMessage('Property removed from your wishlist.');
        setShowSuccess(true);
      } else {
        const res = await axios.post(`${BASE_URL}/user-cart/`, {
          user_id: userId,
          property_id: propertyId,
        });
        setIsWishlisted(true);
        setCartItemId(res.data?.cart_id || res.data?.id || null);
        setIsWishlistRemoved(false); 
        setAlertMessage('Property added to your wishlist.');
        setShowSuccess(true);
      }
    } catch (err) {
      console.error('Wishlist toggle failed:', err);
      setAlertMessage('Failed to update wishlist');
      setShowFailure(true);
    } finally {
      setWishlistLoading(false);
    }
  };

  // ===== SHARE (NOW OPENS MODAL) =====
  const handleShare = () => {
    setShowShareModal(true);
  };

  // ===== USER ACTIVITIES =====
  useEffect(() => {
    const fetchUserActivities = async () => {
      if (!userId) return;
      try {
        const response = await fetch(`${BASE_URL}/activities/`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const allActivities = await response.json();
        const filteredActivities = allActivities.filter(activity =>
          activity && activity.user_id !== undefined && String(activity.user_id) === String(userId)
        );
        setUserActivities(filteredActivities);
      } catch (error) {
        console.error('Error fetching activities:', error);
        setUserActivities([]);
      }
    };
    fetchUserActivities();
  }, [userId]);

  const checkPropertyLimit = (currentPropertyId) => {
    if (!isSubscribed) {
      setFeatureRequested("Property Access");
      setShowSubscribeModal(true);
      return false;
    }
    if (userPlan?.no_of_properties_unlimited) return true;
    const uniqueProperties = new Set(userActivities.map(a => a.property_id));
    const isExistingProperty = uniqueProperties.has(currentPropertyId);
    const propertyLimit = userPlan?.no_of_properties || 10;
    if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
      setShowLimitModal(true);
      return false;
    }
    return true;
  };

  // ===== FIELD MAP (RENT) =====
  const fieldMap = {
    'Commercial land/plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
    'Plot/land': ['Site Area', 'Facing', 'Price', 'Road Width'],
    'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms', 'Lift', 'Road Width'],
    'Duplex house': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms', 'Lift', 'Road Width'],
    'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count', 'Lift', 'Road Width'],
    'Pg-offices': ['Property Name', 'Site Area', 'Facing', 'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
    'Flat': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
    'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Commercial building': ['Property Name', 'Site Area', 'Facing', 'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Apartment': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
    'JV/JD': ['Site Area', 'Facing', 'Price', 'Road Width'],
  };

  const images = property?.property_images && property.property_images.length > 0
    ? property.property_images.map(img => `${BASE_URL}${img.image}`)
    : [buildingImage];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesRes.data);
        if (propertyId) {
          const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
          setProperty(propertyRes.data);
        }
      } catch (err) {
        console.error('Failed to fetch data:', err);
      }
    };
    fetchData();
  }, [propertyId]);

  if (!property) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography>Loading property...</Typography>
      </Box>
    );
  }

  const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
  const categoryName = propertyCategory ? propertyCategory.category : property.type;

  const fieldsToDisplay = fieldMap[categoryName] || [];
  const excludedDisplayFields = ['Site Area', 'Facing', 'Price', 'Road Width', 'No.of Floors', 'Buildup Area'];

  const propertyDetails = fieldsToDisplay.map((field) => {
    switch (field) {
      case 'Site Area': return { label: 'Site Area', value: `${property.site_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
      case 'Facing': return { label: 'Facing', value: property.facing?.replace(/"/g, '') || 'NA', icon: <CompassCalibrationOutlinedIcon /> };
      case 'Price': return { label: 'Price', value: property.price ? property.price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }) : 'NA', icon: <SecurityOutlinedIcon /> };
      case 'Road Width': return { label: 'Road Width', value: `${property.roadwidth || 'NA'} ft`, icon: <CropSquareOutlinedIcon /> };
      case 'No.of Floors': return { label: 'No. of Floors', value: `${property.no_of_flores || 'NA'}`, icon: <LayersOutlinedIcon /> };
      case 'Buildup Area': return { label: 'Buildup Area', value: `${property.buildup_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
      case 'Borewell': return { label: 'Bore Well', value: property.borewell === 'Yes' ? 'Available' : 'Not Available', icon: <OpacityIcon /> };
      case 'No.of Cars Parking': return { label: 'Parking', value: `${property.parking || 'NA'}`, icon: <DirectionsCarIcon /> };
      case '1bhk Count': return { label: '1 BHK', value: property._1bhk_count ? `${property._1bhk_count} No's` : 'NA', icon: <BedIcon /> };
      case '2bhk Count': return { label: '2 BHK', value: property._2bhk_count ? `${property._2bhk_count} No's` : 'NA', icon: <BedIcon /> };
      case '3bhk Count': return { label: '3 BHK', value: property._3bhk_count ? `${property._3bhk_count} No's` : 'NA', icon: <BedIcon /> };
      case '4bhk Count': return { label: '4 BHK', value: property._4bhk_count ? `${property._4bhk_count} No's` : 'NA', icon: <BedIcon /> };
      case 'Duplex Bedrooms': return { label: 'Duplex BHK', value: property.duplex_bedrooms || 'NA', icon: <BedIcon /> };
      case 'Lift': return { label: 'Lift', value: property.lift === 'Yes' ? 'Available' : 'Not Available', icon: <ElevatorIcon /> };
      case 'House Count': return { label: 'House Count', value: property.house_count ? `${property.house_count} No's` : 'NA', icon: <HomeWorkIcon /> };
      default: return null;
    }
  }).filter(detail => detail !== null && !excludedDisplayFields.includes(detail.label));

  const groupedPropertyDetails = [];
  for (let i = 0; i < propertyDetails.length; i += 2) {
    groupedPropertyDetails.push(propertyDetails.slice(i, i + 2));
  }

  // ===== HIGHLIGHTS DATA (RENT) =====
  const highlightsData = [
    { icon: <BedIcon />, value: `${property.duplex_bedrooms || property._1bhk_count || property._2bhk_count || property._3bhk_count || '3'} BHK`, label: '(Duplex)' },
    { icon: <DirectionsCarIcon />, value: `${property.parking || '3'} Cars`, label: '(Covered + Open)' },
    { icon: <HomeWorkIcon />, value: `${property.buildup_area || '2400'} Sq.ft`, label: '(Per Floor)' },
    { icon: <AccountBalanceWalletIcon />, value: `₹ ${property.price ? property.price.toLocaleString('en-IN') : 'NA'}`, label: '(Monthly Rent)' },
    { icon: <CheckCircleOutlineIcon />, value: 'Lift, Power Backup', label: 'Security, CCTV, GST' },
    { icon: <GroupIcon />, value: '100%', label: '(Occupied)' },
    { icon: <EventAvailableIcon />, value: 'Immediate', label: 'Available For' },
  ];

  const groupedHighlights = [];
  for (let i = 0; i < highlightsData.length; i += 2) {
    groupedHighlights.push(highlightsData.slice(i, i + 2));
  }

  const uniqueNames = (list = []) => [
  ...new Set(list.map((x) => (x?.name || '').trim()).filter(Boolean)),
];

const highlightNames = uniqueNames(property.property_highlights);
const amenityNames = uniqueNames(property.property_amenities);

const visibleHighlights = showAllHighlights ? highlightNames : highlightNames.slice(0, 8);

const amenityGroups = groupAmenitiesByCategory(amenityNames);
const presentAmenityCategories = AMENITY_CATEGORIES.filter((c) => amenityGroups[c]?.length > 0);
if (amenityGroups["Other"]?.length) presentAmenityCategories.push("Other");

const amenityCategoriesToShow =
  selectedAmenityCategory === 'All'
    ? presentAmenityCategories
    : presentAmenityCategories.filter((c) => c === selectedAmenityCategory);

  const descriptionText = property.description?.trim() ? property.description : 'No description available.';

  return (
    <Box sx={{ width: '100vw', minHeight: '100vh', backgroundColor: '#F8F3EC', pb: 8 }}>

      {/* ===== HEADER ===== */}
      <Box sx={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10,
        bgcolor: '#3E2A1E', color: 'white',
        px: 2, py: 1.5, display: 'flex', alignItems: 'center',
      }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1, p: 0.5 }}>
          <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <Typography sx={{ flex: 1, fontSize: '1rem', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {categoryName?.replace(/"/g, '') || 'Property'}
        </Typography>
      </Box>

      <Box sx={{ pt: '60px' }}>

        {/* ===== MAIN IMAGE ===== */}
        <Box sx={{ position: 'relative', width: '100%', height: 260, overflow: 'hidden', bgcolor: '#000' }}>
          <Carousel
            selectedItem={selectedImage}
            onChange={(index) => setSelectedImage(index)}
            showThumbs={false} showArrows={false} autoPlay infiniteLoop interval={3000}
            showIndicators={false} showStatus={false} swipeable emulateTouch
            stopOnHover transitionTime={600} useKeyboardArrows
          >
            {images.map((image, index) => (
              <Box key={index} sx={{ width: '100%', height: 260, position: 'relative', overflow: 'hidden' }}>
                <Box component="img" src={image} aria-hidden="true" sx={{
                  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) scale(1.3)',
                  width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(16px)', opacity: 0.7, zIndex: 0,
                }} />
                <Box component="img" src={image} alt="Property" loading="lazy" sx={{
                  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                  width: '100%', height: '100%', objectFit: 'contain', zIndex: 1,
                }} />
                <Box sx={{
                  position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                  pointerEvents: 'none', zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <Typography sx={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', color: 'rgba(255, 255, 255, 0.54)', whiteSpace: 'nowrap' }}>
                    PROPERTY PINCODER
                  </Typography>
                </Box>
              </Box>
            ))}
          </Carousel>

          <Box sx={{
            position: 'absolute', bottom: 10, right: 10, zIndex: 5,
            bgcolor: 'rgba(0,0,0,0.6)', color: 'white',
            px: 1.2, py: 0.3, borderRadius: '20px',
            display: 'flex', alignItems: 'center', gap: 0.5,
          }}>
            <Box component="span" sx={{ fontSize: '0.7rem' }}>📷</Box>
            <Typography sx={{ fontSize: '0.7rem', fontWeight: 600 }}>{selectedImage + 1}/{images.length}</Typography>
          </Box>
        </Box>

        {/* ===== THUMBNAILS ===== */}
        <Box sx={{
          display: 'flex', overflowX: 'auto', gap: 1, px: 1.5, py: 1.5,
          '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none', msOverflowStyle: 'none',
        }}>
          {images.map((image, index) => (
            <Box key={index} onClick={() => handleImageClick(index)} sx={{
              width: 90, minWidth: 90, height: 60, borderRadius: '8px', overflow: 'hidden',
              cursor: 'pointer', flexShrink: 0,
              border: selectedImage === index ? '2px solid #8A6A3D' : '2px solid transparent',
              transition: 'all 0.2s ease',
            }}>
              <Box component="img" src={image} alt={`Thumb ${index + 1}`} loading="lazy"
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Box>
          ))}
          {images.length > 3 && (
            <Box sx={{
              width: 90, minWidth: 90, height: 60, borderRadius: '8px',
              bgcolor: '#3E2A1E', color: 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '0.8rem', fontWeight: 600, flexShrink: 0,
            }}>
              +{images.length - 3}
            </Box>
          )}
        </Box>

        {/* ===== TITLE & PRICE ===== */}
        <Box sx={{ px: 1, mb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
            <Typography sx={{ flex: 1, fontSize: '1.05rem', fontWeight: 700, color: '#222', lineHeight: 1.3 }}>
              {categoryName?.replace(/"/g, '')} {property.property_name ? `- ${property.property_name}` : ''}
            </Typography>
            <Box sx={{
              bgcolor: '#F5DEB3', color: '#5C3D1E',
              px: 1.2, py: 0.5, borderRadius: '8px',
              fontSize: '0.9rem', fontWeight: 700, whiteSpace: 'nowrap',
              border: '1px solid #E8C99A',
            }}>
              ₹ {property.price ? property.price.toLocaleString('en-IN') : 'NA'}
            </Box>
          </Box>
        </Box>

        {/* ===== PROPERTY ID + WISHLIST + SHARE ===== */}
        <Box sx={{ px: 1, mb: 1.5 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 0.8,
              flexWrap: 'nowrap',
            }}
          >
            {/* Property ID Box */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                bgcolor: '#F5DEB3',
                border: '1px solid #E8C99A',
                borderRadius: '8px',
                px: 1,
                py: 0.5,
                flex: 1,
                minWidth: 0,
              }}
            >
              <Typography sx={{ fontSize: '0.75rem', color: '#5C3D1E', fontWeight: 600, whiteSpace: 'nowrap' }}>
                Property Id :
              </Typography>
              <Typography sx={{
                fontSize: '0.75rem', color: '#5C3D1E', fontWeight: 700,
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {property.id || propertyId}
              </Typography>
            </Box>

            {/* Wishlist Button */}
            <Tooltip title={isWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist'}>
              <Box
                onClick={handleWishlistToggle}
                sx={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5,
                  bgcolor: '#FFF', border: '1px solid #E8C99A',
                  borderRadius: '8px', px: 1.2, py: 0.5,
                  cursor: wishlistLoading ? 'wait' : 'pointer',
                  flexShrink: 0, transition: 'all 0.2s',
                  '&:hover': { bgcolor: '#FDF3E7' },
                }}
              >
                {wishlistLoading ? (
                  <CircularProgress size={16} sx={{ color: '#E53935' }} />
                ) : isWishlisted ? (
                  <Favorite sx={{ fontSize: 18, color: '#E53935' }} />
                ) : (
                  <FavoriteBorder sx={{ fontSize: 18, color: '#5C3D1E' }} />
                )}
                <Typography sx={{
                  fontSize: '0.72rem', fontWeight: 700,
                  color: isWishlisted ? '#E53935' : '#5C3D1E',
                  whiteSpace: 'nowrap',
                }}>
                  {isWishlisted ? 'Wishlisted' : 'Wishlist'}
                </Typography>
              </Box>
            </Tooltip>

            {/* Share Button */}
            <Tooltip title="Share this property">
              <Box
                onClick={handleShare}
                sx={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5,
                  bgcolor: '#FFF', border: '1px solid #E8C99A',
                  borderRadius: '8px', px: 1.2, py: 0.5,
                  cursor: 'pointer', flexShrink: 0, transition: 'all 0.2s',
                  '&:hover': { bgcolor: '#FDF3E7' },
                }}
              >
                <ShareIcon sx={{ fontSize: 18, color: '#5C3D1E' }} />
                <Typography sx={{
                  fontSize: '0.72rem', fontWeight: 700, color: '#5C3D1E', whiteSpace: 'nowrap',
                }}>
                  Share
                </Typography>
              </Box>
            </Tooltip>
          </Box>

          {/* Location text */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}>
            <Typography sx={{ fontSize: '0.8rem', color: '#555', lineHeight: 1.4 }}>
              {property.location || 'Not Specified'}
            </Typography>
          </Box>
        </Box>

        {/* ===== SITE AREA / ROAD WIDTH / FACING ===== */}
        <Box sx={{ px: 1, mb: 1.5 }}>
          <Box sx={{
            display: 'flex', justifyContent: 'space-between',
            bgcolor: '#FBF5ED', border: '1px solid #E8DCC8',
            borderRadius: '10px', p: 1.5,
          }}>
            <Box sx={{ textAlign: 'center', flex: 1 }}>
              <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
                <HomeWorkIcon />
              </Box>
              <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
                {property.site_area || property.max_acres ? (() => {
                  const value = property.site_area || property.max_acres;
                  const unitRaw = property.units || '';
                  const unit = unitRaw.toLowerCase();
                  if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) return `${value} ${unitRaw}`;
                  const hasSq = unit.includes('sq');
                  return `${value} ${hasSq ? unitRaw : `Sq ${unitRaw || 'ft'}`}`;
                })() : 'NA'}
              </Typography>
              <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Site Area</Typography>
            </Box>
            <Box sx={{ width: '1px', bgcolor: '#E8DCC8' }} />
            <Box sx={{ textAlign: 'center', flex: 1 }}>
              <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
                <StraightenIcon />
              </Box>
              <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
                {property.roadwidth || 'NA'} ft
              </Typography>
              <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Road Width</Typography>
            </Box>
            <Box sx={{ width: '1px', bgcolor: '#E8DCC8' }} />
            <Box sx={{ textAlign: 'center', flex: 1 }}>
              <Box sx={{ color: '#8A6A3D', mb: 0.3, '& svg': { fontSize: 20 } }}>
                <CompassCalibrationOutlinedIcon />
              </Box>
              <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#222' }}>
                {property.facing?.replace(/"/g, '') || 'NA'}
              </Typography>
              <Typography sx={{ fontSize: '0.65rem', color: '#777' }}>Facing</Typography>
            </Box>
          </Box>
        </Box>

        {/* ===== PROPERTY HIGHLIGHTS ===== */}
        <Box sx={{ px: 1, mb: 1.5 }}>
          <Box sx={{
            bgcolor: '#FFFFFF', border: '1px solid #E8DCC8',
            borderRadius: '12px', p: 1.5,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                <HomeIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
                <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
                  Property Highlights
                </Typography>
              </Box>
              <Box sx={{
                bgcolor: '#F5DEB3', color: '#5C3D1E',
                px: 1, py: 0.2, borderRadius: '4px',
                fontSize: '0.7rem', fontWeight: 600,
                border: '1px solid #E8C99A',
              }}>
                For Rent
              </Box>
            </Box>

            <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 0.5 }}>
              {groupedHighlights.map((row, rowIndex) => (
                <Box
                  key={rowIndex}
                  sx={{
                    display: 'flex', width: '100%',
                    borderBottom: rowIndex !== groupedHighlights.length - 1 ? '1px solid #F0E6D6' : 'none',
                  }}
                >
                  {row.map((item, colIndex) => (
                    <Box
                      key={colIndex}
                      sx={{
                        flex: '0 0 50%',
                        display: 'flex', alignItems: 'center', gap: 1,
                        py: 1.2, px: 0.5, boxSizing: 'border-box',
                        borderRight: colIndex === 0 ? '1px solid #F0E6D6' : 'none',
                        minWidth: 0,
                      }}
                    >
                      <Box sx={{
                        color: '#8A6A3D', flexShrink: 0,
                        display: 'flex', alignItems: 'center',
                        '& svg': { fontSize: 20 },
                      }}>
                        {item.icon}
                      </Box>
                      <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
                        <Typography sx={{
                          fontSize: '0.85rem', fontWeight: 600, color: '#222',
                          lineHeight: 1.2, whiteSpace: 'normal', wordBreak: 'break-word',
                        }}>
                          {item.value}
                        </Typography>
                        <Typography sx={{
                          fontSize: '0.7rem', color: '#777',
                          lineHeight: 1.2, whiteSpace: 'normal', wordBreak: 'break-word',
                        }}>
                          {item.label}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                  {row.length === 1 && <Box sx={{ flex: '0 0 50%' }} />}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* ===== PROPERTY DETAILS (Collapsible) ===== */}
        <Box sx={{ px: 1, mb: 1.5 }}>
          <Accordion expanded={detailsExpanded} onChange={() => setDetailsExpanded(!detailsExpanded)}
            sx={{
              borderRadius: '12px !important', border: '1px solid #E8DCC8',
              boxShadow: 'none', '&:before': { display: 'none' },
              '&.Mui-expanded': { margin: 0 },
            }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#8A6A3D' }} />}
              sx={{ px: 1.5, minHeight: 48, '&.Mui-expanded': { minHeight: 48 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                <ApartmentIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
                <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
                  Property Details
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
              <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 1.5 }}>
                {groupedPropertyDetails.map((row, rowIndex) => (
                  <Box key={rowIndex} sx={{ display: 'flex', width: '100%', borderBottom: rowIndex !== groupedPropertyDetails.length - 1 ? '1px solid #F0E6D6' : 'none' }}>
                    {row.map((item, colIndex) => (
                      <Box key={colIndex} sx={{
                        flex: '0 0 50%', display: 'flex', alignItems: 'center', gap: 1,
                        py: 1.2, px: 0.5, boxSizing: 'border-box',
                        borderRight: colIndex === 0 ? '1px solid #F0E6D6' : 'none',
                        minWidth: 0,
                      }}>
                        <Box sx={{ color: '#8A6A3D', flexShrink: 0, display: 'flex', alignItems: 'center', '& svg': { fontSize: 20 } }}>
                          {item.icon}
                        </Box>
                        <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
                          <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222', lineHeight: 1.2 }}>
                            {item.value}
                          </Typography>
                          <Typography sx={{ fontSize: '0.7rem', color: '#777', lineHeight: 1.2 }}>
                            {item.label}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                    {row.length === 1 && <Box sx={{ flex: '0 0 50%' }} />}
                  </Box>
                ))}

                {/* Length * Width */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CropSquareOutlinedIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
                    <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Length * Width</Typography>
                  </Box>
                  <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
                    {property.length && property.width ? (() => {
                      const unitRaw = property.units || "";
                      const unit = unitRaw.toLowerCase();
                      if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) return `${property.length} * ${property.width} ${unitRaw}`;
                      return `${property.length} * ${property.width} Sq ${unitRaw || 'ft'}`;
                    })() : "NA"}
                  </Typography>
                </Box>

                {/* Average Price */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <SecurityOutlinedIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
                    <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Average Price</Typography>
                  </Box>
                  <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
                    {property.price ? (() => {
                      let area = 0;
                      if (property.buildup_area) {
                        area = parseFloat(property.buildup_area);
                        const floors = parseInt(property.no_of_flores || property.floor || 0);
                        if (floors > 0) area = area * floors;
                      } else if (property.site_area || property.max_acres) {
                        area = parseFloat(property.site_area || property.max_acres);
                      }
                      if (!area || area <= 0) return "NA";
                      const avgPrice = parseFloat(property.price) / area;
                      const unitRaw = property.units || "";
                      const unit = unitRaw.toLowerCase();
                      if (["acre", "acres", "gunta", "guntas"].includes(unit)) return `₹${avgPrice.toFixed(2)} / ${unitRaw}`;
                      const hasSq = unit.includes("sq");
                      return `₹${avgPrice.toFixed(2)} / ${hasSq ? unitRaw : `Sq ${unitRaw || "ft"}`}`;
                    })() : "NA"}
                  </Typography>
                </Box>

                {/* Posted On */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderTop: '1px solid #F0E6D6' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TodayIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
                    <Typography sx={{ fontSize: '0.85rem', color: '#555' }}>Posted On</Typography>
                  </Box>
                  <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#222' }}>
                    {formatIndianDate(property.created_at)}
                  </Typography>
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>

        {/* ADDED COMPONENT */}
        <AddPropertyCards />

        {/* ===== PROPERTY HIGHLIGHTS ===== */}
{highlightNames.length > 0 && (
  <Box sx={{ px: 0.5, mb: 1 }}>
    <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
      <CardContent sx={{ p: 0.5 }}>
        <SectionHeaderWithViewAll
          title="Property Highlights"
          onViewAll={highlightNames.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
          expanded={showAllHighlights}
        />
        <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
      </CardContent>
    </Card>
  </Box>
)}

{/* ===== AMENITIES ===== */}
{amenityNames.length > 0 && (
  <Box sx={{ px: 0.5, mb: 1 }}>
    <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
      <CardContent sx={{ p: 0.5 }}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
          Amenities
        </Typography>

        <Box
          sx={{
            mb: 2, mt: 1, overflowX: 'auto', whiteSpace: 'nowrap',
            borderBottom: `1px solid ${COLORS.border}`,
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          <Box sx={{ display: 'inline-flex' }}>
            {['All', ...presentAmenityCategories].map((cat) => {
              const isActive = selectedAmenityCategory === cat;
              const count = cat === 'All' ? amenityNames.length : amenityGroups[cat]?.length || 0;
              return (
                <Box
                  key={cat}
                  onClick={() => setSelectedAmenityCategory(cat)}
                  sx={{
                    px: 1.5, py: 1, cursor: 'pointer', flexShrink: 0,
                    borderBottom: isActive ? `2px solid ${COLORS.primaryDark}` : '2px solid transparent',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '13px',
                      fontWeight: isActive ? 700 : 500,
                      color: isActive ? COLORS.primaryDark : COLORS.textSecondary,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {cat} ({count})
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        {amenityCategoriesToShow.map((cat) => (
          <Box key={cat} sx={{ mb: 2 }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark, mb: 1 }}>
              {cat}
            </Typography>
            <IconGrid items={amenityGroups[cat]} />
          </Box>
        ))}
      </CardContent>
    </Card>
  </Box>
)}

        {/* ===== DESCRIPTION ===== */}
        <Box sx={{ px: 0.5, mb: 0.5 }}>
          <Accordion
            expanded={descriptionExpanded}
            onChange={() => { /* locked open */ }}
            sx={{
              borderRadius: '12px !important',
              border: '1px solid #E8DCC8',
              boxShadow: 'none',
              '&:before': { display: 'none' },
              '&.Mui-expanded': { margin: 0 },
            }}
          >
            <AccordionSummary
              expandIcon={null}
              sx={{ px: 0.5, minHeight: 30, '&.Mui-expanded': { minHeight: 48 }, cursor: 'default' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <DescriptionIcon sx={{ color: '#8A6A3D', fontSize: 20 }} />
                <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#222' }}>
                  Description
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 1, pt: 0 }}>
              <Box sx={{ borderTop: '1px solid #F0E6D6', pt: 1 }}>
                <Typography
                  sx={{
                    fontSize: '0.8rem',
                    color: '#555',
                    lineHeight: 1.6,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: descriptionClampExpanded ? 'unset' : 5,
                    overflow: 'hidden',
                  }}
                >
                  {descriptionText}
                </Typography>

                <Box
                  onClick={() => setDescriptionClampExpanded(!descriptionClampExpanded)}
                  sx={{
                    mt: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    cursor: 'pointer',
                    color: '#8A6A3D',
                    fontWeight: 700,
                    fontSize: '0.8rem',
                    userSelect: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#8A6A3D' }}>
                    {descriptionClampExpanded ? 'Show Less' : 'Show More'}
                  </Typography>
                  <ExpandMoreIcon
                    sx={{
                      fontSize: 18,
                      color: '#8A6A3D',
                      transition: 'transform 0.2s',
                      transform: descriptionClampExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  />
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>

        {/* ===== SELLER CARD (Posted time + name + role + Chat now) ===== */}
        <Box sx={{ px: 0.5, mb: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              bgcolor: '#FFFFFF',
              border: '1px solid #EEE',
              borderRadius: '12px',
              px: 1.5,
              py: 1.2,
              boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
            }}
          >
            {/* Left: avatar + text */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, minWidth: 0 }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  bgcolor: '#a87c51',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  fontWeight: 700,
                  fontSize: '1rem',
                  overflow: 'hidden',
                }}
              >
                {property?.user_first_name ? (
                  property.user_first_name.charAt(0).toUpperCase()
                ) : (
                  <PersonIcon sx={{ fontSize: 24 }} />
                )}
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    fontSize: '0.72rem',
                    color: '#888',
                    lineHeight: 1.2,
                    fontWeight: 500,
                  }}
                >
                  Posted {formatTimeAgo(property?.created_at)} by
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.95rem',
                    fontWeight: 700,
                    color: '#222',
                    lineHeight: 1.25,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 180,
                  }}
                >
                  {getSellerName(property)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.75rem',
                    color: '#666',
                    lineHeight: 1.2,
                  }}
                >
                  {property?.posted_by || 'Owner'}
                </Typography>
              </Box>
            </Box>

            {/* Right: Chat now + caption */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', flexShrink: 0 }}>
              <Box
                onClick={handleChatNowClick}
                sx={{
                  bgcolor: '#a87c51',
                  color: '#fff',
                  px: 2,
                  py: 0.9,
                  borderRadius: '10px',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  '&:hover': { bgcolor: '#a87c51' },
                }}
              >
                Chat now
              </Box>
              <Typography sx={{ fontSize: '0.65rem', color: '#888', mt: 0.4 }}>
                Free, fast &amp; secure
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ===== ACTION BUTTONS: View Number + View on Map ===== */}
        <Box
          sx={{
            px: 0.5,
            mb: 1,
            display: 'flex',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          {/* View Number */}
          <Box
            onClick={handleViewNumberClick}
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              bgcolor: '#FDF8F2',
              border: '1px solid #a87c51',
              borderRadius: '8px',
              px: 1,
              py: 1.2,
              cursor: 'pointer',
              transition: 'all 0.2s',
              '&:hover': { bgcolor: '#F5ECE0' },
            }}
          >
            <CallIcon sx={{ color: '#6B3620', fontSize: 22 }} />
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#6B3620' }}>
              View Number
            </Typography>
          </Box>

          {/* View on Map */}
          <Box
            onClick={handleOpenMapLocation}
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              bgcolor: '#FDF8F2',
              border: '1px solid #a87c51',
              borderRadius: '8px',
              px: 1,
              py: 1.2,
              cursor: 'pointer',
              transition: 'all 0.2s',
              '&:hover': { bgcolor: '#F5ECE0' },
            }}
          >
            <LocationOnIcon sx={{ color: '#6B3620', fontSize: 22 }} />
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#6B3620' }}>
              View on Map
            </Typography>
          </Box>
        </Box>

      </Box>

      {/* ===== MODALS & ALERTS ===== */}
      {showSubscribeModal && (
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center', borderRadius: 3 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">Subscription Required</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>Please subscribe to use the {featureRequested} feature.</Typography>
            <Button variant="contained" onClick={() => setShowSubscribeModal(false)} sx={{ bgcolor: '#8A6A3D', '&:hover': { bgcolor: '#6d5230' } }}>OK</Button>
          </Paper>
        </Box>
      )}

      {showLimitModal && (
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center', borderRadius: 3 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">Limit Exceeded</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {userPlan?.no_of_properties_unlimited ? "You have unlimited access to properties." : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. Please upgrade your subscription plan for more.`}
            </Typography>
            <Button variant="contained" onClick={() => setShowLimitModal(false)} sx={{ bgcolor: '#8A6A3D', '&:hover': { bgcolor: '#6d5230' } }}>OK</Button>
          </Paper>
        </Box>
      )}

      {showSuccess && (
        <WishlistSuccessAlert
          message={alertMessage}
          isRemoved={isWishlistRemoved}
          onClose={() => { setShowSuccess(false); setAlertMessage(""); }}
        />
      )}
      {showFailure && <CopyFailureAlert message={alertMessage} onClose={() => { setShowFailure(false); setAlertMessage(""); }} />}

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />

      {/* --- NEW CUSTOM MODALS --- */}
      <ChatModal 
        open={showChatModal} 
        onClose={() => setShowChatModal(false)} 
        onOpenChat={confirmOpenChat} 
      />

      <PhoneModal 
        open={showPhoneModal} 
        onClose={() => setShowPhoneModal(false)} 
        ownerName={getSellerName(property)} 
        mobileNo={property?.mobile_no} 
      />

      <MapModal 
        open={showMapModal} 
        onClose={() => setShowMapModal(false)} 
        onOpenMap={executeOpenMap} 
      />

      <ShareModal 
        open={showShareModal} 
        onClose={() => setShowShareModal(false)}
        ownerName={getSellerName(property)}
        mobileNo={property?.mobile_no}
      />

      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
        <CustomBottomNav />
      </Paper>
    </Box>
  );
};

export default Rent_description;